import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import moment from 'moment';
import { Grid, FormControl, Tooltip, Button, Dialog, DialogTitle, Box, DialogContent, DialogActions, TextField, Autocomplete, CircularProgress, Checkbox, FormGroup, FormControlLabel, Typography, FormLabel, RadioGroup, Radio, InputAdornment, Table, TableHead, TableBody, TableRow, TableCell, Paper, Link, TableContainer } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import InfoIcon from '@mui/icons-material/Info';
import SvClaimDetails from './SvClaimDetails';
import EscalationDetails from './EscalationDetails';
import ProRateDetails from './ProRateDetails';
import { RangeConditionTable } from './custom_table';
import useGetApiHook from '../hooks/useGetApiHook';
import useValidationHook from '../hooks/useValidationHook';
import { addReserveRateApi, updateReserveRateApi, getProductServiceDropdownApi, getChartOfAccountDropdownApi, getClassesDropdownApi, getSubClassesDropdownApi, getMajorAssemblyApi} from '../apiService';
import { getQbStatusApi } from '../../quickBooks/apiService';
import { CustomRatioDerateTable, DerateBasedRatioTable, InterpolationExtrapolation } from '../../elements';
import { assetTypeMap } from '../../leases/components/LeaseConstants';
import { backendDateFormat, displayDateFormatShort, fieldDateFormat } from '../../../constants';
import { checkApiStatus, getGlobalCookie, numberWithCommas } from '../../../utils';
import { globalGetService, globalPostService, globalPutService } from '../../../utils/globalApiServices';
import { AttachementsUpload } from '../../../shared_elements/components';
import { regexConstants } from '../../../constants/regEx';
import { isValidYearRange, sortingArray } from '../../../utils/helper';
import { setFileUploadDetails } from '../../../shared_elements/actions';
import { formatBytes } from '../../../utils/fileUpload';
import { trackActivity } from '../../../utils/mixpanel';
import { avationPlcInstance, leshaBankInstance, MTAviationInstance, PageLoader, hanwahaInstance, jetStreamInstance, gaTelesisInstance } from '../../../shared_elements';
import LGGroupingAllocation from './LgGroupingAllocation';
import { useNavigate } from "react-router-dom";
import { fetchLeaseBasicDetails } from '../../../shared_elements/actionCreators';
import { eolAdjArr } from '.';

const ReserveRateCRU = ({ onToggleModal, onOpenAttachments, fileUpload, modeType, params, addEditReserveRate, getResponseBack }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { storageDetails } = useSelector((state) => state.leases);
    const { enqueueSnackbar } = useSnackbar();
    const { leaseBasicDetails } = useSelector((state) => state.leases);
    const fixedTableDefaults = {
        fixed: null,
        fc_rate: null,
        fh_rate: null,
    };
    const normalizeFixedTableCondition = (condition) => ({
        ...fixedTableDefaults,
        ...(condition || {}),
    });
    const normalizeFixedTableFlag = (value) => value === true || value === "true" || value === 1;
    const fixedTableRows = [
        { key: "fixed", label: "Fixed" },
        { key: "fc_rate", label: "Flight Cycles" },
        { key: "fh_rate", label: "Flight Hours" },
    ];
    const handlePbhRangeTypeChange = (value) => {
        const isFixedTable = value === "fixed";
        const isFixedRate = value === "fixed_rate";
        const isAll = value === "true";

        setError((prev) => {
            const next = { ...prev };
            delete next.fixed_table_condition;
            return next;
        });

        setReserveRates((prev) => ({
            ...prev,
            is_pbh_fixed_table: isFixedTable,
            fixed_rate: isFixedRate,
            pbh_range_type: isFixedTable ? prev?.pbh_range_type : isAll,
            fixed_table_condition: isFixedTable
                ? normalizeFixedTableCondition(prev?.fixed_table_condition)
                : prev?.fixed_table_condition,
        }));
    };
    const [isQbEnabled, setIsQbEnabled] = useState(false);
    const [qbStatusLoading, setQbStatusLoading] = useState(jetStreamInstance || hanwahaInstance);
    const updatedReserveData = {
        ...addEditReserveRate,
        data: {
            ...addEditReserveRate?.data,
            rate_escalation_percentage: addEditReserveRate?.data?.rate_escalation_percentage ? addEditReserveRate?.data?.rate_escalation_percentage : "",
            interpolation_option: addEditReserveRate?.data?.interpolation_option ? addEditReserveRate?.data?.interpolation_option?.value : null,
            extrapolation_option: addEditReserveRate?.data?.extrapolation_option ? addEditReserveRate?.data?.extrapolation_option?.value : null,
            allow_decimal: addEditReserveRate?.data?.allow_decimal ? { ...addEditReserveRate?.data?.allow_decimal, value: addEditReserveRate?.data?.allow_decimal } : null,
            is_pbh_fixed_table: normalizeFixedTableFlag(addEditReserveRate?.data?.is_pbh_fixed_table),
            fixed_rate: normalizeFixedTableFlag(addEditReserveRate?.data?.fixed_rate),
            base_reading_escaltaion: normalizeFixedTableFlag(addEditReserveRate?.data?.base_reading_escaltaion),
            fixed_table_condition: normalizeFixedTableCondition(addEditReserveRate?.data?.fixed_table_condition),
            pbh_condition: addEditReserveRate?.data?.pbh_condition?.map(item => ({
                ...item,
                min: item.min != null ? Number(item.min) : 0,
                max: item.max != null ? Number(item.max) : 0,
                ...(item.rate != null && { rate: Number(item.rate) }),
            })),
            interval_condition: addEditReserveRate?.data?.interval_condition?.map(item => ({
                ...item,
                ...(item.rate != null && { rate: Number(item.rate) }),
                ...(item.ratio != null && { ratio: Number(item.ratio) }),
                ...(item.derate != null && { derate: Number(item.derate) }),
                ...(item.ratios && {
                    ratios: item.ratios.map(r => ({
                        ...r,
                        ...(r.rate != null && { rate: Number(r.rate) }),
                        ...(r.ratio != null && { ratio: Number(r.ratio) }),
                    }))
                }),
            })),
        }
    }
    const [reserveRates, setReserveRates] = useState(updatedReserveData?.data);
    const [isLoading, setLoading] = useState({ skeletonLoader: false, pageLoader: false });
    const [excelData, setExcelData] = useState([]);
    const toggleLoader = (type, status) => { setLoading({ ...isLoading, [type]: status }) }
    const { pltConstants, filteredIntervalData, setPltConstants, setDropDownLoader, filteredIntervalList, dropDownLoader, getOptionForInterval, getMaintenanceEvent, getEngineLLPs, getEngineThrust, uploadFiles, getAssetDropDown, } = useGetApiHook(params, modeType, updatedReserveData, toggleLoader)
    const { checkRangeConditionsValiadation, checkRatioValidation } = useValidationHook()
    const [error, setError] = useState({});
    const [attachedFiles, setAttachedFiles] = useState([]);
    const [eolAdjFields, setEolAdjFields] = useState(eolAdjArr);
    const [productServices, setProductServices] = useState([]);
    const [chartOfAccounts, setChartOfAccounts] = useState([]);
    const [classes, setClasses] = useState([]);
    const [subClasses, setSubClasses] = useState([]);
    const [qbDropDownLoader, setQbDropDownLoader] = useState({ productService: false, chartOfAccount: false, class: false, subClass: false });

    useEffect(() => {
        if (!reserveRates?.eol_adjustment) return;
        const updated = eolAdjFields?.map((item) => ({
            ...item,
            value: reserveRates.eol_adjustment[item.key] ? 1 : 0
        }));
        setEolAdjFields(updated);
    }, [reserveRates]);
    const getMajorAssembly = () => {
        setDropDownLoader((prev) => ({ ...prev, major_assembly: true }));
        globalGetService(getMajorAssemblyApi(params))
            .then((response) => {
                setDropDownLoader((prev) => ({ ...prev, major_assembly: false }));
                if (checkApiStatus(response)) {
                    let updatedMajorAssembly = response?.data?.data || [];
                    const isLGGrouped = leaseBasicDetails?.is_grouped || (modeType !== "add" && reserveRates?.is_grouped_lgs);
                    const groupedItems = updatedMajorAssembly?.filter((item) => item.asset_type === 4 && (isLGGrouped || item.is_grouped === true));
                    const otherItems = updatedMajorAssembly.filter((item) => !(item.asset_type === 4 && item.is_grouped === true));
                    const updatedOtherItems = otherItems?.filter((item) => !(isLGGrouped && item.asset_type === 4));
                    const finalItems = isLGGrouped ? updatedOtherItems : otherItems;
                    const count = modeType !== "add" && reserveRates?.lg_allocations?.length > 0 ? reserveRates.lg_allocations.length : groupedItems?.length || 0;
                    const lgGroupName = `LG Group (${Array.from({ length: count }, (_, index) => `LG${index + 1}`).join(", ")})`;
                    if (groupedItems.length > 0) {
                        finalItems.push({
                            asset_id: groupedItems?.[0]?.id,
                            asset_slug: groupedItems?.[0]?.asset_slug,
                            asset_type: 4,
                            is_grouped: isLGGrouped,
                            name: lgGroupName,
                        });
                    }
                    if (count > 0) {
                        const baseValue = Math.floor((100 / count) * 100) / 100;
                        const remaining = +(100 - baseValue * count).toFixed(2);
                        const updatedLGData = modeType !== "add" && reserveRates?.lg_allocations?.length > 0 ? reserveRates?.lg_allocations : groupedItems;
                        const updatedGroupedItems =
                            updatedLGData?.map((item, index) => ({
                                ...item,
                                asset_id: item?.asset_id || item?.id,
                                name: item?.name?.includes(`LG${index + 1}`) ? item?.name : `LG${index + 1} - ${(item?.asset_name || item?.name || "")?.replace(/^LG\s*-\s*/i, "")}`,
                                percentage: modeType !== "add" ? (item?.percentage ?? (index === count - 1 ? +(baseValue + remaining).toFixed(2) : baseValue)) : (index === count - 1 ? +(baseValue + remaining).toFixed(2) : baseValue),
                            }));
                        setReserveRates((prev) => ({
                            ...prev,
                            lg_allocations: updatedGroupedItems,
                        }));
                    }
                    const updatedGroup = groupedItems?.map((item) => ({ ...item, is_grouped: isLGGrouped, }));
                    setPltConstants((prev) => ({ ...prev, asset_types: finalItems, lg_asset_types: updatedGroup, }));
                    if (
                        reserveRates?.major_assembly?.asset_type === 4 &&
                        isLGGrouped
                    ) {
                        setReserveRates((prev) => ({
                            ...prev,
                            major_assembly: {
                                asset_id: groupedItems?.[0]?.id,
                                asset_slug: groupedItems?.[0]?.asset_slug,
                                asset_type: 4,
                                is_grouped: true,
                                name: lgGroupName,
                            },
                        }));
                    }


                } else {
                    enqueueSnackbar(response?.data?.message, { variant: "error", hideIconVariant: true, anchorOrigin: { vertical: "top", horizontal: "right", }, });
                }
            });
    };

    useEffect(() => {
        getMajorAssembly()
        globalGetService(getQbStatusApi()).then(response => {
            if (checkApiStatus(response) && response.data.data?.is_lessor_enabled) {
                setIsQbEnabled(true)
                getProductServices()
                getChartOfAccountsList()
                if (hanwahaInstance) getClassesList()
            }
            setQbStatusLoading(false)
        })
    }, [])

    useEffect(() => {
        const classId = reserveRates?.qb_class_id?.id;
        setSubClasses([]);
        if (!hanwahaInstance || !classId) {
            return;
        }
        setQbDropDownLoader(prev => ({ ...prev, subClass: true }))
        globalGetService(getSubClassesDropdownApi(classId, leaseBasicDetails?.lessor?.id))
            .then(response => {
                setQbDropDownLoader(prev => ({ ...prev, subClass: false }))
                if (checkApiStatus(response)) {
                    setSubClasses(response.data.data)
                }
            })
    }, [reserveRates?.qb_class_id])

    const isLGGrouping = ((leaseBasicDetails?.is_grouped || reserveRates?.is_grouped_lgs) && reserveRates?.major_assembly?.is_grouped && reserveRates?.lg_allocations?.length > 0) || false

    const getProductServices = () => {
        setQbDropDownLoader(prev => ({ ...prev, productService: true }))
        globalGetService(getProductServiceDropdownApi(leaseBasicDetails?.lessor?.id))
            .then(response => {
                setQbDropDownLoader(prev => ({ ...prev, productService: false }))
                if (checkApiStatus(response)) {
                    setProductServices(response.data.data)
                }
            })
    }

    const getChartOfAccountsList = () => {
        setQbDropDownLoader(prev => ({ ...prev, chartOfAccount: true }))
        globalGetService(getChartOfAccountDropdownApi(leaseBasicDetails?.lessor?.id))
            .then(response => {
                setQbDropDownLoader(prev => ({ ...prev, chartOfAccount: false }))
                if (checkApiStatus(response)) {
                    setChartOfAccounts(response.data.data)
                }
            })
    }

    const getClassesList = () => {
        setQbDropDownLoader(prev => ({ ...prev, class: true }))
        globalGetService(getClassesDropdownApi(leaseBasicDetails?.lessor?.id))
            .then(response => {
                setQbDropDownLoader(prev => ({ ...prev, class: false }))
                if (checkApiStatus(response)) {
                    setClasses(response.data.data)
                }
            })
    }

    const onAddRangeCondition = (rangeCondition) => {
        let selectedRange;
        const updatedRangeCondition = pltConstants?.constant_types?.filter(ele => ele.type === "mr_rate_range_condition");
        const defaultObj = { type: rangeCondition, rate: 0, esc_percentage: 0, min: 0, max: 0, esc_date: null };
        const existingRows = (reserveRates?.pbh_condition || [])?.filter(r => r.type === rangeCondition);
        const hasLT = existingRows?.some(r => r.ratio_range === 1);
        const hasGT = existingRows?.some(r => r.ratio_range === 3);
        if (!hasLT) { selectedRange = updatedRangeCondition.find(r => r.value === 1); }
        else if (!hasGT) { selectedRange = updatedRangeCondition.find(r => r.value === 3); }
        else { selectedRange = updatedRangeCondition.find(r => r.value === 2); }
        const rentalRateType = rangeCondition !== 8 ? { label: selectedRange.value === 2 ? "PER UNIT" : "FIXED", value: selectedRange.value === 2 ? 2 : 1 } : undefined;
        const updatedObject = {
            ratio_range: selectedRange.value,
            range_label: selectedRange.label,
            ...defaultObj,
            ...(rentalRateType && { rental_rate_type: rentalRateType }),
        };
        return updatedObject;

    };

    const onFieldChange = (key, value) => {
        const isEdit = (modeType === "edit");
        const updatedData = updatedReserveData?.data;
        const isSame = (field, compareVal = value?.value) => isEdit && updatedData?.[field]?.value === compareVal;
        const sameMajorAssembly = isEdit && updatedData?.major_assembly?.asset_slug === value?.asset_slug;
        const sameReserveBasedOn = isSame("reserve_rate_based_on")
        const updatedValues = { [key]: value, };
        const errorResetMap = {
            is_additional_amount: ["additional_amount"],
            max_cap_applicable: ["max_cap_amount"],
            rate_start_date: ["rate_start_date"],
            rate_end_date: ["rate_end_date"],
            rate_escalation_interval: ["rate_escalation_start_date"],
            reserve_rate_type: ["interval", "reserve_rate_per_interval", "reserve_rate_based_on"],
            major_assembly: ["interval", "reserve_rate_per_interval", "reserve_rate_based_on"],
        };
        if (errorResetMap[key]) {
            const clearedErrors = { ...error };
            errorResetMap[key].forEach(errKey => clearedErrors[errKey] = "");
            setError(clearedErrors);
        }
        const fieldDefaults = { major_assembly: null, reserve_rate_type: null, interval: null, reserve_rate_per_interval: "", reserve_rate_based_on: null, pbh_condition: [], interval_condition: [], pbh_range_type: false, is_pbh_fixed_table: false, fixed_rate: false, base_reading_escaltaion: false, fixed_table_condition: fixedTableDefaults, maintenance_check_id: null, table_based_esc: false, rate_escalation_percentage: "", rate_escalation_start_date: null, rate_escalation_interval: null, is_interpolation: false, is_extrapolation: false, interpolation_option: null, extrapolation_option: null, claim_type: { value: 1, label: "PRSV" }, claim_event_type: { value: 1, label: "Fund" }, engine_split_details: [], allow_decimal: null, rounding: null, round_off_escalation: null, is_base_reading: false, region_based_esc: false };
        const groupByFieldType = {
            major_assembly: ["reserve_rate_type", "reserve_rate_based_on", "pbh_condition", "interval_condition", "pbh_range_type", "is_pbh_fixed_table", "fixed_rate", "base_reading_escaltaion", "fixed_table_condition", "maintenance_check_id", "table_based_esc", "rate_escalation_percentage", "rate_escalation_start_date", "rate_escalation_interval", "is_interpolation", "is_extrapolation", "interpolation_option", "extrapolation_option", "claim_type", "claim_event_type", "engine_split_details", "allow_decimal", "rounding", "round_off_escalation", "is_base_reading", "engine_thrust_types"],
            reserve_rate_type: ["interval", "reserve_rate_per_interval", "reserve_rate_based_on", "pbh_condition", "interval_condition", "pbh_range_type", "is_pbh_fixed_table", "fixed_rate", "base_reading_escaltaion", "fixed_table_condition", "table_based_esc", "rate_escalation_percentage", "rate_escalation_start_date", "rate_escalation_interval", "is_interpolation", "is_extrapolation", "interpolation_option", "extrapolation_option", "allow_decimal", "rounding", "round_off_escalation", "is_base_reading"],
            reserve_rate_based_on: ["interval", "pbh_condition", "interval_condition", "pbh_range_type", "is_pbh_fixed_table", "fixed_rate", "base_reading_escaltaion", "fixed_table_condition", "table_based_esc", "rate_escalation_percentage", "rate_escalation_start_date", "rate_escalation_interval", "is_interpolation", "is_extrapolation", "interpolation_option", "extrapolation_option", "allow_decimal", "rounding", "round_off_escalation", "is_base_reading"],
        };
        const applyFields = (updatedValues, updatedData, fields, condition) => {
            fields.forEach((field) => {
                updatedValues[field] = condition
                    ? updatedData?.[field] ?? fieldDefaults[field]
                    : fieldDefaults[field];
            });
        }
        if (key === "major_assembly") {
            if ((value?.id || value?.asset_id) && value?.asset_type) { getMaintenanceEvent(value) }
            applyFields(updatedValues, updatedData, groupByFieldType.major_assembly, sameMajorAssembly);
            updatedValues.region_based_esc = (value?.asset_type === 2 && sameMajorAssembly) ? (updatedData?.region_based_esc ?? false) : false;
        }
        if (key === "reserve_rate_type") {
            getOptionForInterval(value, reserveRates?.major_assembly?.asset_type, pltConstants?.constant_types)
            const sameRateType = isSame("reserve_rate_type")
            const isSameAccountAssemblyType = updatedData?.account_type?.value === reserveRates?.account_type?.value && updatedData?.major_assembly?.asset_slug === reserveRates?.major_assembly?.asset_slug && sameRateType
            applyFields(updatedValues, updatedData, groupByFieldType.reserve_rate_type, isSameAccountAssemblyType);
        }
        else if (key === "reserve_rate_based_on") {
            const reserveBasedOnCondition = updatedData?.account_type?.value === reserveRates?.account_type?.value && updatedData?.major_assembly?.asset_slug === reserveRates?.major_assembly?.asset_slug && updatedData?.reserve_rate_type?.value === reserveRates?.reserve_rate_type?.value && sameReserveBasedOn
            applyFields(updatedValues, updatedData, groupByFieldType.reserve_rate_based_on, reserveBasedOnCondition);
            setError({})
        }
        else if (key === "table_based_esc") {
            const tableEscMatch = isEdit && updatedData?.account_type?.value === reserveRates?.account_type?.value &&
                updatedData?.major_assembly?.asset_slug === reserveRates?.major_assembly?.asset_slug &&
                updatedData?.reserve_rate_based_on?.value === reserveRates?.reserve_rate_based_on?.value && value === updatedData?.table_based_esc
            updatedValues.rate_escalation_percentage = tableEscMatch ? updatedData?.rate_escalation_percentage : ""
            updatedValues.rate_escalation_start_date = tableEscMatch ? updatedData?.rate_escalation_start_date : null
            updatedValues.round_off_escalation = tableEscMatch ? updatedData?.round_off_escalation : null
            if (reserveRates?.pbh_condition?.length > 0) {
                updatedValues.pbh_condition = tableEscMatch
                    ? (
                        reserveRates?.pbh_condition?.map(item => {
                            const prev = updatedData.pbh_condition?.find(u => u.id === item.id);
                            return prev
                                ? { ...item, esc_percentage: prev.esc_percentage, esc_date: prev.esc_date }
                                : { ...item, esc_percentage: 0, esc_date: null };
                        })
                    )
                    : (
                        reserveRates?.pbh_condition?.map(item => ({
                            ...item,
                            esc_percentage: 0,
                            esc_date: null
                        }))
                    );
            }
        }
        else if (key === "qb_class_id") {
            updatedValues.qb_sub_class_id = null;
        }
        else if (key === "is_prorated") {
            updatedValues.days = isEdit && (updatedData?.is_prorated === "true" || updatedData?.is_prorated === true) ? updatedData?.days : "";
        }
        else if (key === "is_base_reading") {
            updatedValues.base_ratio = null; updatedValues.base_derate = null; updatedValues.base_rate = null; updatedValues.base_reading_escaltaion = false;
        }
        else if (key === "base_reading_escaltaion") {
            if (!value) {
                setError(prev => ({
                    ...prev,
                    rate_escalation_percentage: "",
                    rate_escalation_interval: "",
                    rate_escalation_start_date: "",
                }));
            }
        }
        else if (key === "allow_decimal") {
            updatedValues.is_base_reading = false
        }
        else if (key === "is_pbh_fixed_table") {
            const pbhFixedMatch = isEdit &&
                updatedData?.account_type?.value === reserveRates?.account_type?.value &&
                updatedData?.major_assembly?.asset_slug === reserveRates?.major_assembly?.asset_slug &&
                updatedData?.reserve_rate_type?.value === reserveRates?.reserve_rate_type?.value &&
                updatedData?.reserve_rate_based_on?.value === reserveRates?.reserve_rate_based_on?.value &&
                value === updatedData?.is_pbh_fixed_table
            updatedValues.round_off_escalation = pbhFixedMatch ? updatedData?.round_off_escalation : null
            if (value === true) {
                updatedValues.fixed_table_condition = isEdit && updatedData?.is_pbh_fixed_table ? normalizeFixedTableCondition(updatedData?.fixed_table_condition) : normalizeFixedTableCondition(reserveRates?.fixed_table_condition);
            } else {
                setError(prev => {
                    const next = { ...prev };
                    delete next.fixed_table_condition;
                    return next;
                });
            }
        }
        else if (key === "fixed_table_condition") {
            updatedValues.fixed_table_condition = {
                ...normalizeFixedTableCondition(reserveRates?.fixed_table_condition),
                ...value,
            };
            if ("fc_rate" in (value || {}) || "fh_rate" in (value || {})) {
                setError((prev) => ({
                    ...prev, fixed_table_condition: {
                        ...prev?.fixed_table_condition,
                        fc_rate: "",
                        fh_rate: "",
                    },
                }));
            }
        }
        else if (key === "is_interpolation") {
            const fieldMatch = updatedData?.account_type?.value === reserveRates?.account_type?.value && updatedData?.major_assembly?.asset_slug === reserveRates?.major_assembly?.asset_slug && updatedData?.reserve_rate_type?.value === reserveRates?.reserve_rate_type?.value && reserveRates?.reserve_rate_based_on?.value === updatedData?.reserve_rate_based_on?.value
            updatedValues.interpolation_option = isEdit && value === updatedData?.is_interpolation && fieldMatch ? updatedData?.interpolation_option : null
        }
        else if (key === "is_extrapolation") {
            const fieldMatch = updatedData?.account_type?.value === reserveRates?.account_type?.value && updatedData?.major_assembly?.asset_slug === reserveRates?.major_assembly?.asset_slug && updatedData?.reserve_rate_type?.value === reserveRates?.reserve_rate_type?.value && reserveRates?.reserve_rate_based_on?.value === updatedData?.reserve_rate_based_on?.value
            updatedValues.extrapolation_option = isEdit && value === updatedData?.is_extrapolation && fieldMatch ? updatedData?.extrapolation_option : null
        }
        else if (key === "rate_escalation_interval") {
            if (!value) {
                updatedValues.rate_escalation_interval = null;
                updatedValues.rate_escalation_start_date = null;
            } else {
                if (!reserveRates?.table_based_esc) {
                    updatedValues.rate_escalation_start_date =
                        isEdit && updatedData?.rate_escalation_interval?.value === value?.value
                            ? updatedData?.rate_escalation_start_date
                            : reserveRates?.rate_start_date
                                ? moment(reserveRates?.rate_start_date).add(1, 'year').format(backendDateFormat)
                                : null;
                }
            }
        }
        else if (key === "interval") {
            if (value?.value === 1) {
                updatedValues.max_cap_applicable = false;
                updatedValues.max_cap_amount = "";
            }
        }
        else if (key === "is_additional_amount") {
            updatedValues.additional_amount = isEdit && updatedData?.is_additional_amount === value ? updatedData?.additional_amount : 0;
        }
        else if (key === "max_cap_applicable") {
            updatedValues.max_cap_amount = isEdit && updatedData?.max_cap_applicable === value ? updatedData?.max_cap_amount : 0;
        }
        else if (key === "claim_type") {
            const sameClaimType = isSame("claim_type")
            updatedValues.claim_event_type = updatedData?.account_type?.value === reserveRates?.account_type?.value && updatedData?.major_assembly?.asset_slug === reserveRates?.major_assembly?.asset_slug && sameClaimType ? updatedData?.claim_event_type : { value: 1, label: "Fund" };
            updatedValues.engine_split_details = updatedData?.account_type?.value === reserveRates?.account_type?.value && updatedData?.major_assembly?.asset_slug === reserveRates?.major_assembly?.asset_slug && sameClaimType ? updatedData?.engine_split_details : []
        } else if (key === "claim_event_type" && reserveRates?.major_assembly?.asset_type === 2) {
            if (isEdit && updatedData?.account_type?.value === reserveRates?.account_type?.value && updatedData?.major_assembly?.asset_slug === reserveRates?.major_assembly?.asset_slug && reserveRates?.claim_type?.value === updatedData?.claim_type?.value && value?.value === updatedData?.claim_event_type?.value) {
                updatedValues.engine_split_details = updatedData?.engine_split_details
            }
            else if (reserveRates?.major_assembly?.asset_slug && (value?.value === 2 || value?.value === 3)) {
                if (reserveRates?.claim_type?.value === 2 && value?.value === 3) {
                    getEngineLLPs(assetTypeMap[reserveRates?.major_assembly?.asset_type], reserveRates?.major_assembly?.asset_slug, "description").then(llpData => {
                        updatedValues.engine_split_details = llpData;
                        setReserveRates({
                            ...reserveRates,
                            ...updatedValues,
                        });
                    })
                }
                else {
                    getEngineLLPs(assetTypeMap[reserveRates?.major_assembly?.asset_type], reserveRates?.major_assembly?.asset_slug, "module").then(llpData => {
                        updatedValues.engine_split_details = llpData;
                        setReserveRates({
                            ...reserveRates,
                            ...updatedValues,
                        });
                    })
                }
            } else {
                updatedValues.engine_split_details = []
            }
        }
        const newState = { ...reserveRates, ...updatedValues };
        const newRoudingCondition =
            newState?.reserve_rate_type?.value === 1 ||
            (newState?.reserve_rate_type?.value === 2 &&
                newState?.reserve_rate_based_on?.value &&
                !newState?.table_based_esc &&
                (newState?.reserve_rate_based_on?.value !== 4 || !newState?.is_pbh_fixed_table)) ||
            (newState?.reserve_rate_type?.value === 3 &&
                newState?.reserve_rate_based_on?.value &&
                !(newState?.reserve_rate_based_on?.value === 8 && newState?.table_based_esc));
        if (!newRoudingCondition) {
            updatedValues.round_off_escalation = null;
        }

        setReserveRates({
            ...reserveRates,
            ...updatedValues,
        });

        if (key === 'allow_decimal') {
            onMultiFieldChange('', '', '', '', 'allow_decimal')
        }
    }
    const onFocusChange = (key) => { setError({ ...error, [key]: "" }) }
    const onAddMultiRow = (rangeCondition) => {
        const rangeConditionErrors = {};
        const rangeConditionFields = [];
        if (!reserveRates?.interval) {
            rangeConditionErrors.interval = "Please select Reserve Rate interval";
            rangeConditionFields.push("Reserve Rate Interval");
        }
        if (!reserveRates?.allow_decimal) {
            rangeConditionErrors.allow_decimal = "Please select Allow Decimal";
            rangeConditionFields.push("Allow Decimal");
        }
        if (!reserveRates?.rounding && [8, 9, 11].includes(rangeCondition)) {
            rangeConditionErrors.rounding = "Please select Rounding";
            rangeConditionFields.push("Rounding");
        }
        if (rangeConditionFields.length > 0 && reserveRates?.reserve_rate_type?.value === 3) {
            const fieldList = rangeConditionFields.length < 3 ? rangeConditionFields.join(' and ') : `${rangeConditionFields.slice(0, -1).join(', ')} and ${rangeConditionFields.at(-1)}`;
            enqueueSnackbar(`Please select ${fieldList} field(s).`, { variant: "error", hideIconVariant: true, anchorOrigin: { vertical: "top", horizontal: "right" } });
            setError(prev => ({ ...prev, ...rangeConditionErrors }));
            return;
        }
        let addObject
        let arrKey
        if ([2, 3, 4, 6, 8].includes(rangeCondition)) {
            arrKey = "pbh_condition"
            addObject = onAddRangeCondition(rangeCondition)
        } else {
            arrKey = "interval_condition";
            addObject = { rate: 0, type: rangeCondition, ...(rangeCondition === 9 ? { ratio: 0 } : { derate: 0 }) };
        }
        setReserveRates(prev => {
            const updatedData = prev[arrKey] || [];
            const combinedData = [...updatedData, addObject];
            let newList;
            if (arrKey === "pbh_condition") {
                const lessThan = combinedData?.filter(item => item.ratio_range === 1);
                const greaterThan = combinedData?.filter(item => item.ratio_range === 3);
                const inBetween = combinedData?.filter(item => item.ratio_range === 2)
                newList = [...lessThan, ...inBetween, ...greaterThan];
            } else {
                newList = combinedData
            }
            return { ...prev, [arrKey]: newList };
        });
    };
    const onMultiFieldChange = (arrKey, rowIndex, field, value, allowKey) => {
        if (allowKey) {
            const newData = reserveRates?.interval_condition?.map(row => ({
                ...row, ratio: 0, rate: 0, derate: 0,
                ratios: row?.ratios?.map(r =>
                    ({ ...r, rate: 0 })
                )
            }));
            setReserveRates(prev => ({ ...prev, "interval_condition": newData }));
        } else {
            const updatedArray = (reserveRates && arrKey && [...reserveRates[arrKey]]) || [];
            const newData = updatedArray.map((row, index) => {
                if (index === rowIndex) { return { ...row, [field]: value }; }
                return row;
            });
            setReserveRates((prev) => ({ ...prev, [arrKey]: newData, }));
        }
    };
    const onMultiDelete = (arrKey, rowIndex) => {
        setReserveRates((prev) => ({ ...prev, [arrKey]: prev[arrKey]?.filter((_, index) => index !== rowIndex), }));
        if (arrKey === "interval_condition") {
            setError(prev => {
                const updated = { ...prev };
                Object.keys(updated).forEach((k) => { if (/^row_\d+$/.test(k) || /^\d+$/.test(k)) delete updated[k]; });
                return updated;
            });
        }
    }

    const handleFileChange = (files) => {
        setAttachedFiles(files);
        dispatch(setFileUploadDetails({ attachments: files }))
    };
    const validateAllocationLimit = ({ list = [], fieldName, label = 'Allocation limit', }) => {
        if (list?.length > 0) {
            const total = list.reduce((sum, item) => Number(sum) + (Number(item?.[fieldName]) || 0), 0);
            if (total > 100) { enqueueSnackbar(`${label} limit is 100%. Please reduce the values.`, { variant: 'error', hideIconVariant: true, anchorOrigin: { vertical: 'top', horizontal: 'right' }, }); return false; }
            if (total < 100) { enqueueSnackbar(`${label} limit is 100%. Please increase the values.`, { variant: 'error', hideIconVariant: true, anchorOrigin: { vertical: 'top', horizontal: 'right' }, }); return false; }
        }
        return true;
    };
    const onAddEditReserveRate = () => {
        const reserve_rate_based_on = reserveRates?.reserve_rate_based_on;
        const isFixedRateMode = reserveRates?.fixed_rate === true
            && reserveRates?.reserve_rate_type?.value === 2
            && reserveRates?.reserve_rate_based_on?.value === 4;
        const shouldRequireRatePerInterval = !reserveRates?.reserve_rate_type || reserveRates?.reserve_rate_type?.value === 1 || isFixedRateMode;
        const requireBaseReadingEscalation = reserveRates?.is_base_reading && reserveRates?.base_reading_escaltaion === true;
        let validationInputs = {};
        let hasMultiError = { isValid: true }
        const startDate = moment(reserveRates?.rate_start_date);
        const endDate = moment(reserveRates?.rate_end_date);
        validationInputs = {
            name: reserveRates?.name ? "" : "Please enter Reserve Name",
            major_assembly: !reserveRates?.major_assembly?.name ? "Please select Major Assembly" : "",
            rate_start_date: !reserveRates?.rate_start_date ? "Please select Start Date" : !moment(reserveRates?.rate_start_date).isValid() ? "Please select valid Start Date" : !isValidYearRange(reserveRates?.rate_start_date) ? "Year must be between 1900 and 2100." : "",
            rate_end_date: reserveRates?.rate_end_date ? !moment(reserveRates?.rate_end_date).isValid() ? "Please select valid End Date" : moment(reserveRates.rate_end_date).isBefore(moment(reserveRates.rate_start_date)) ? "End date must be after Start Date" : !isValidYearRange(reserveRates?.rate_end_date) ? "Year must be between 1900 and 2100." : "" : [5, 3].includes(leaseBasicDetails?.lease_duration_type?.value) ? "" : "Please select End Date",
            reserve_rate_type: reserveRates?.reserve_rate_type ? "" : "Please select Reserve Rate Type",
            interval: reserveRates?.reserve_rate_type && !([1, 3].includes(reserveRates?.reserve_rate_type?.value)) ? "" : !reserveRates?.interval ? "Please select Reserve Rate Interval" : "",
            reserve_rate_per_interval: shouldRequireRatePerInterval ? (reserveRates?.reserve_rate_per_interval === null || reserveRates?.reserve_rate_per_interval === "" || reserveRates?.reserve_rate_per_interval === undefined) ? "Please enter Rate / Unit" : "" : "",
            reserve_rate_based_on: !reserveRates?.reserve_rate_based_on && reserveRates?.reserve_rate_type?.value !== 1 ? "Please select Reserve Rate Based On" : "",
            maintenance_check_id: !reserveRates?.maintenance_check_id ? "Please select Maintenance Event" : "",
            currency: !reserveRates?.currency ? "Please select Currency" : "",
            qb_product_and_service_id: isQbEnabled && !reserveRates?.qb_product_and_service_id ? "Please select Product & Service" : "",
            qb_chart_of_account_id: isQbEnabled && !reserveRates?.qb_chart_of_account_id ? "Please select Chart of Account" : "",
            qb_class_id: isQbEnabled && hanwahaInstance && !reserveRates?.qb_class_id ? "Please select Class" : "",
            qb_sub_class_id: isQbEnabled && hanwahaInstance && !reserveRates?.qb_sub_class_id ? "Please select Sub Class" : "",
            max_cap_amount: !reserveRates?.max_cap_applicable ? "" : reserveRates?.max_cap_amount ? reserveRates?.max_cap_amount > 0 ? "" : 'Max Cap Amount must be greater than 0' : reserveRates?.max_cap_amount === 0 ? 'Max Cap Amount must be greater than 0' : "Please enter Max Cap Amount",
            additional_amount: !reserveRates?.is_additional_amount ? "" : reserveRates?.reserve_rate_type?.value === 1 && !reserveRates?.additional_amount ? "Please enter Additional Cost" : "",
            rate_escalation_percentage: requireBaseReadingEscalation
                ? (reserveRates?.rate_escalation_percentage === null || reserveRates?.rate_escalation_percentage === undefined || reserveRates?.rate_escalation_percentage === "")
                    ? "Please enter Reserve Rate Escalation"
                    : Number(reserveRates?.rate_escalation_percentage) > 100
                        ? "Reserve Rate Escalation must be below 100%"
                        : ""
                : reserveRates?.table_based_esc || reserveRates?.rate_escalation_percentage ? "" : (reserveRates?.rate_escalation_interval !== null || reserveRates?.rate_escalation_start_date !== null) ? "Please enter Reserve Rate Escalation" : reserveRates?.rate_escalation_percentage > 100 ? "Reserve Rate Escalation must be below 100%" : "",
            rate_escalation_interval: requireBaseReadingEscalation
                ? (reserveRates?.rate_escalation_interval ? "" : "Please select Escalation Interval")
                : reserveRates?.table_based_esc || reserveRates?.rate_escalation_interval ? "" : (reserveRates?.rate_escalation_percentage !== "" || reserveRates?.rate_escalation_start_date !== null) ? "Please enter Escalation Interval" : "",
            rate_escalation_start_date: requireBaseReadingEscalation
                ? (reserveRates?.rate_escalation_start_date ? "" : "Please enter Escalation Start Date")
                : reserveRates?.table_based_esc || reserveRates?.rate_escalation_start_date ? "" : (reserveRates?.rate_escalation_percentage !== "" || reserveRates?.rate_escalation_interval !== null) ? "Please enter Escalation Start Date" : moment(reserveRates.rate_escalation_start_date).isBefore(moment(reserveRates.rate_start_date)) ? "Escalation Start Date must be after Start Date" : moment(reserveRates.rate_escalation_start_date).isAfter(moment(reserveRates.rate_end_date)) ? "Escalation Start Date must be before End Date" : reserveRates?.rate_escalation_start_date && !isValidYearRange(reserveRates?.rate_escalation_start_date) ? "Year must be between 1900 and 2100." : "",
            days: reserveRates?.interval?.value === 1 && (reserveRates?.is_prorated === "true" || reserveRates?.is_prorated === true) && !reserveRates?.days ? "Please enter Number of Day's" : reserveRates?.days && (reserveRates?.days < 28 || reserveRates?.days > 31) ? "Please enter Number of Day's between 28 to 31." : "",
            allow_decimal: ([8, 9, 10, 11].includes(reserveRates?.reserve_rate_based_on?.value)) ? reserveRates?.allow_decimal ? "" : "Please select Allow Decimal" : "",
            rounding: ([8, 9, 11].includes(reserveRates?.reserve_rate_based_on?.value)) ? reserveRates?.rounding ? "" : "Please select Rounding" : '',
            base_ratio: reserveRates?.is_base_reading && ([9, 11].includes(reserveRates?.reserve_rate_based_on?.value)) ? (reserveRates?.base_ratio ? "" : "Please enter Base Ratio") : "",
            base_derate: reserveRates?.is_base_reading && ([10, 11].includes(reserveRates?.reserve_rate_based_on?.value)) ? (reserveRates?.base_derate ? "" : "Please enter Base Derate") : "",
            base_rate: reserveRates?.is_base_reading ? (reserveRates?.base_rate ? "" : "Please enter Base Rate") : "",
        };
        if (reserveRates?.is_pbh_fixed_table) {
            const fixedTableCondition = reserveRates?.fixed_table_condition || {};
            validationInputs.fixed_table_condition = {
                fixed: fixedTableCondition?.fixed === "" || fixedTableCondition?.fixed === null || fixedTableCondition?.fixed === undefined ? "Please enter Fixed Rate" : Number(fixedTableCondition?.fixed) > 0 ? "" : "Fixed should be greater than 0",
                fc_rate: fixedTableCondition?.fh_rate && Number(fixedTableCondition?.fh_rate) > 0 ? "" : fixedTableCondition?.fc_rate === "" || fixedTableCondition?.fc_rate === null || fixedTableCondition?.fc_rate === undefined ? "Please enter either FC or FH" : Number(fixedTableCondition?.fc_rate) > 0 ? "" : "FC Rate should be greater than 0",
                fh_rate: fixedTableCondition?.fc_rate && Number(fixedTableCondition?.fc_rate) > 0 ? "" : fixedTableCondition?.fh_rate === "" || fixedTableCondition?.fh_rate === null || fixedTableCondition?.fh_rate === undefined ? "Please enter either FH or FC" : Number(fixedTableCondition?.fh_rate) > 0 ? "" : "FH Rate should be greater than 0",
            };
        }
        if (reserveRates?.reserve_rate_type?.value !== 1 && !reserveRates?.is_pbh_fixed_table && !isFixedRateMode && [2, 3, 4, 6, 8].includes(reserve_rate_based_on?.value)) { hasMultiError = checkRangeConditionsValiadation(reserveRates, "pbh_condition", error, setError); }
        else if ([9, 10, 11].includes(reserve_rate_based_on?.value)) { hasMultiError = checkRatioValidation(reserveRates && reserveRates?.interval_condition, reserve_rate_based_on) }
        if (gaTelesisInstance && reserveRates?.reserve_rate_type?.value === 3 && reserveRates?.reserve_rate_based_on?.value === 11) {
            const ic = reserveRates?.interval_condition || [];
            let blankCellCount = 0;
            let zeroCellCount = 0;
            ic.forEach((col) => {
                (col?.ratios || []).forEach((r) => {
                    if (r?.rate === '' || r?.rate === undefined || r?.rate === null) blankCellCount += 1;
                    else if (Number(r.rate) === 0) zeroCellCount += 1;
                });
            });
            const ratioValues = (ic[0]?.ratios || []).map((r) => {
                const num = Number(r.ratio);
                return isNaN(num) ? r.ratio : num;
            });
            const duplicateRatioCount = new Set(ratioValues.filter((v, i) => ratioValues.indexOf(v) !== i)).size;
            const ratioIssues = [];
            if (blankCellCount > 0) ratioIssues.push(`${blankCellCount} empty cell(s)`);
            if (zeroCellCount > 0) ratioIssues.push(`${zeroCellCount} cell(s) with a 0 rate`);
            if (duplicateRatioCount > 0) ratioIssues.push(`${duplicateRatioCount} duplicate Ratio/DeRate value(s)`);
            if (ratioIssues.length > 0) {
                enqueueSnackbar(`Ratio/DeRate Table has ${ratioIssues.join(', ')}. Please review the table before saving.`, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
                setError(prev => ({ ...prev, ...hasMultiError?.errors }));
                return;
            }
        }
        const isEngineValid = validateAllocationLimit({ list: reserveRates?.engine_split_details, fieldName: 'fund_allocation_percentage', label: 'Fund allocation', });
        const isLgValid = isLGGrouping ? validateAllocationLimit({ list: reserveRates?.lg_allocations, fieldName: 'percentage', label: 'Invoice Amount Allocation', }) : true
        if (!isEngineValid) return;
        if (!isLgValid) return;

        if (reserveRates?.rate_start_date && reserveRates?.rate_end_date) {
            if (endDate.isBefore(startDate)) {
                validationInputs.rate_end_date = "End date cannot be before Start Date";
            }
            if (startDate.isAfter(endDate)) {
                validationInputs.rate_start_date = "Start date cannot be after End Date";
            }
            if (startDate.isBefore(leaseBasicDetails?.contractual_start_date)) {
                validationInputs.rate_start_date = `Start date cannot be before contract start date ${moment(leaseBasicDetails?.contractual_start_date)?.format(fieldDateFormat) ?? ""}`;
            }
            if (startDate.isAfter(leaseBasicDetails?.end_date)) {
                validationInputs.rate_start_date = "Start date cannot be after lease end date";
            }
            if (endDate.isAfter(leaseBasicDetails?.end_date)) {
                validationInputs.rate_end_date = "End date cannot be after lease end date";
            }
            if (endDate.isBefore(leaseBasicDetails?.contractual_start_date)) {
                validationInputs.rate_end_date = `End date cannot be before contract start date ${moment(leaseBasicDetails?.contractual_start_date)?.format(fieldDateFormat) ?? ""}`;
            }
        }

        if (reserveRates?.rate_start_date && reserveRates?.rate_end_date && reserveRates.rate_escalation_start_date) {
            if (moment(reserveRates.rate_escalation_start_date).isBefore(startDate)) {
                validationInputs.rate_escalation_start_date = "Escalation date cannot be before Start Date";
            }
            if (moment(reserveRates?.rate_escalation_start_date).isAfter(endDate)) {
                validationInputs.rate_escalation_start_date = "Escalation date cannot be after End Date";
            }
        }
        if (reserveRates.rate_escalation_start_date && !moment(reserveRates.rate_escalation_start_date).isValid()) validationInputs['rate_escalation_start_date'] = "Please select valid Escalation Start Date";
        const isValidationClear = Object.keys(validationInputs).every((k) => {
            const fieldValue = validationInputs[k];
            if (fieldValue && typeof fieldValue === "object" && !Array.isArray(fieldValue)) {
                return Object.values(fieldValue).every((value) => value === "");
            }
            return fieldValue === "";
        });
        if (isValidationClear && hasMultiError?.isValid) {
            const updatedObject = (obj) => {
                if (!obj || typeof obj !== 'object') { return obj; }
                const { type, remarks, ...rest } = obj;
                return rest;
            };
            const eol_adjustment = Object.fromEntries(eolAdjFields?.map(item => [item?.key, item?.value === 1 ? true : false]));
            const fixedTableCondition = reserveRates?.is_pbh_fixed_table ? {
                fixed: reserveRates?.fixed_table_condition?.fixed === "" || reserveRates?.fixed_table_condition?.fixed === null || reserveRates?.fixed_table_condition?.fixed === undefined ? null : Number(reserveRates?.fixed_table_condition?.fixed),
                fc_rate: reserveRates?.fixed_table_condition?.fc_rate === "" || reserveRates?.fixed_table_condition?.fc_rate === null || reserveRates?.fixed_table_condition?.fc_rate === undefined ? null : Number(reserveRates?.fixed_table_condition?.fc_rate),
                fh_rate: reserveRates?.fixed_table_condition?.fh_rate === "" || reserveRates?.fixed_table_condition?.fh_rate === null || reserveRates?.fixed_table_condition?.fh_rate === undefined ? null : Number(reserveRates?.fixed_table_condition?.fh_rate),
            } : null;
            const hasFixedTable = reserveRates?.is_pbh_fixed_table === true;
            let payload
            const groupedLGItems = pltConstants?.lg_asset_types?.filter((item) => item.asset_type === 4 && item.is_grouped === true);
            const updatedLGAllocation = { name: groupedLGItems?.[0]?.name || groupedLGItems?.[0]?.asset_name, asset_slug: groupedLGItems?.[0]?.asset_slug, asset_id: groupedLGItems?.[0]?.id, asset_type: Number(groupedLGItems?.[0]?.asset_type) }
            const updatedPayload = {
                ...reserveRates,
                reserve_rate_per_interval: shouldRequireRatePerInterval ? Number(reserveRates?.reserve_rate_per_interval) : null,
                interval: [1, 3].includes(reserveRates?.reserve_rate_type?.value) ? updatedObject(reserveRates.interval) : null,
                is_additional_amount: reserveRates?.reserve_rate_type?.value === 1 ? reserveRates?.is_additional_amount : false,
                additional_amount: reserveRates?.reserve_rate_type?.value === 1 && reserveRates?.is_additional_amount ? Number(reserveRates?.additional_amount) : null,
                max_cap_amount: reserveRates?.max_cap_applicable ? Number(reserveRates?.max_cap_amount) : null,
                major_assembly: isLGGrouping ? updatedLGAllocation : { asset_slug: reserveRates?.major_assembly?.asset_slug, asset_type: Number(reserveRates?.major_assembly?.asset_type), asset_id: Number(reserveRates?.major_assembly?.asset_id || reserveRates?.major_assembly?.id), name: reserveRates?.major_assembly?.asset_type === 1 ? reserveRates?.major_assembly?.payloadName : (reserveRates?.major_assembly?.asset_name || reserveRates?.major_assembly?.name) },
                reserve_rate_type: updatedObject(reserveRates.reserve_rate_type),
                account_type: reserveRates?.account_type ? reserveRates?.account_type : null,
                maintenance_check_id: reserveRates?.maintenance_check_id ? reserveRates?.maintenance_check_id : null,
                currency: reserveRates?.currency ? reserveRates?.currency?.code : null,
                rate_escalation_percentage: reserveRates?.table_based_esc ? null : Number(reserveRates?.rate_escalation_percentage),
                rate_escalation_interval: reserveRates?.table_based_esc ? null : updatedObject(reserveRates.rate_escalation_interval),
                rate_escalation_start_date: reserveRates?.table_based_esc ? null : reserveRates?.rate_escalation_start_date,
                round_off_escalation: (
                    reserveRates?.reserve_rate_type?.value === 1 ||
                    (reserveRates?.reserve_rate_type?.value === 2 &&
                        reserveRates?.reserve_rate_based_on?.value &&
                        !reserveRates?.table_based_esc &&
                        (reserveRates?.reserve_rate_based_on?.value !== 4 || !reserveRates?.is_pbh_fixed_table)) ||
                    (reserveRates?.reserve_rate_type?.value === 3 &&
                        reserveRates?.reserve_rate_based_on?.value &&
                        !(reserveRates?.reserve_rate_based_on?.value === 8 && reserveRates?.table_based_esc))
                ) ? updatedObject(reserveRates.round_off_escalation) : null,
                interval_condition: reserveRates?.interval_condition?.length > 0 && reserveRates?.reserve_rate_type?.value !== 1 ? reserveRates?.interval_condition : [],
                pbh_condition: !hasFixedTable && !isFixedRateMode && reserveRates?.pbh_condition?.length > 0 && reserveRates?.reserve_rate_type?.value !== 1 ? reserveRates?.pbh_condition : [],
                pbh_range_type: !hasFixedTable && !isFixedRateMode && (reserveRates?.pbh_range_type === "true" || reserveRates?.pbh_range_type === true) ? true : false,
                fixed_rate: isFixedRateMode,
                base_reading_escaltaion: reserveRates?.is_base_reading && reserveRates?.base_reading_escaltaion === true || false,
                ...(hasFixedTable ? { is_pbh_fixed_table: true, fixed_table_condition: fixedTableCondition } : {}),
                claim_type: reserveRates?.major_assembly?.asset_type === 2 ? reserveRates?.claim_type : { value: 1, label: "PRSV" },
                claim_event_type: reserveRates?.major_assembly?.asset_type === 2 ? reserveRates?.claim_event_type : { value: 1, label: "Fund" },
                days: reserveRates?.interval?.value === 1 && (reserveRates?.is_prorated === "true" || reserveRates?.is_prorated === true) ? Number(reserveRates?.days) : 0,
                allow_decimal: ([8, 9, 10, 11].includes(reserveRates?.reserve_rate_based_on?.value)) ? reserveRates?.allow_decimal?.value : null,
                rounding: ([8, 9, 11].includes(reserveRates?.reserve_rate_based_on?.value)) ? reserveRates?.rounding?.value : null,
                is_interpolation: reserveRates?.reserve_rate_type?.value === 3 && reserveRates?.interpolation_option && [1].includes(Number(reserveRates?.interpolation_option)) ? true : false,
                is_extrapolation: reserveRates?.reserve_rate_type?.value === 3 && reserveRates?.extrapolation_option && [1, 3].includes(Number(reserveRates?.extrapolation_option)) ? true : false,
                interpolation_option: reserveRates?.reserve_rate_type?.value === 3 && reserveRates?.interpolation_option ? Number(reserveRates?.interpolation_option) : null,
                extrapolation_option: reserveRates?.reserve_rate_type?.value === 3 && reserveRates?.extrapolation_option ? Number(reserveRates?.extrapolation_option) : null,
                engine_thrust_types: reserveRates?.engine_thrust_types ? reserveRates?.engine_thrust_types : null,
                eol_adjustment: eol_adjustment ? eol_adjustment : null,
                is_grouped_lgs: isLGGrouping || false,
                region_based_esc: reserveRates?.major_assembly?.asset_type === 2 ? (reserveRates?.region_based_esc === true) : false,
                qb_product_and_service_id: reserveRates?.qb_product_and_service_id ? reserveRates?.qb_product_and_service_id : null,
                qb_chart_of_account_id: reserveRates?.qb_chart_of_account_id ? reserveRates?.qb_chart_of_account_id : null,
                qb_class_id: reserveRates?.qb_class_id ? reserveRates?.qb_class_id : null,
                qb_sub_class_id: reserveRates?.qb_sub_class_id ? reserveRates?.qb_sub_class_id : null,
                lg_allocations:isLGGrouping ? (reserveRates?.lg_allocations || []).map(
                    ({ id, percentage, ...rest }, index) => ({
                        ...rest,
                        name:
                            pltConstants?.lg_asset_types?.find(
                                (item) => item.asset_slug === rest.asset_slug
                            )?.name || rest.name,
                        percentage: Number(percentage) || 0,
                    })
                ) : []
            };
            if (!hasFixedTable) {
                delete updatedPayload.is_pbh_fixed_table;
                delete updatedPayload.fixed_table_condition;
            }
            if (reserveRates?.interval?.value === 1) {
                payload = {
                    ...updatedPayload,
                    is_prorated: reserveRates?.interval?.value === 1 ? reserveRates?.is_prorated === "true" || reserveRates?.is_prorated === true ? true : false : null,
                }
            } else {
                delete updatedPayload?.is_prorated
                payload = updatedPayload
            }
            setLoading({ ...isLoading, pageLoader: true });
            if (reserveRates?.id) {
                globalPutService(updateReserveRateApi(params), payload)
                    .then(async (response) => {
                        if (checkApiStatus(response)) {
                            if (attachedFiles?.length > 0) {
                                fileUpload(reserveRates.slug, 'updated', attachedFiles, getResponseBack)
                            }
                            onToggleModal();
                            getResponseBack();
                            setLoading({ pageLoader: false });
                            enqueueSnackbar(response?.data?.message, { variant: "success", hideIconVariant: true, anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Reserve Rate`, success_msg: response?.data?.message, item_id: reserveRates?.id, payload: payload, response: response?.data })
                        } else {
                            setLoading({ pageLoader: false });
                            enqueueSnackbar(response.data.message, { variant: "error", hideIconVariant: true, anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Reserve Rate`, error_msg: response?.data?.message, item_id: reserveRates?.id, payload: payload, response: response?.data })
                        }
                    })
            } else {
                globalPostService(addReserveRateApi(params), payload).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachedFiles?.length > 0) {
                            fileUpload(response?.data?.data?.slug, 'created', attachedFiles, getResponseBack)
                        }
                        dispatch(fetchLeaseBasicDetails({ slug: params?.leaseSlug, setLoading }));
                        onToggleModal();
                        getResponseBack();
                        setLoading({ pageLoader: false });
                        enqueueSnackbar(response?.data?.message, { variant: "success", hideIconVariant: true, anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add Reserve Rate`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: payload, response: response?.data })
                    } else {
                        setLoading({ pageLoader: false });
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
                        trackActivity('Item Added', { page_title: `Add Reserve Rate`, hideIconVariant: true, error_msg: response?.data?.message, item_id: null, payload: payload, response: response?.data })
                    }
                })
            }
        } else {
            setError({ ...validationInputs, ...hasMultiError.errors, })
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Reserve Rate`, error_msg: validationInputs, })
        }
    }

    const handleEolAdjFields = (index, val) => {
        setEolAdjFields(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], value: val };
            return updated;
        });
    };
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Reserve Rate`, page_type: page_type, })
    }
    const onImportExcel = () => {
        if (!excelData?.length) return;
        const key = [9, 10].includes(reserveRates?.reserve_rate_based_on?.value) ? "interval_condition" : "pbh_condition";
        const currentType = excelData[0]?.type;
        setReserveRates((prev) => {
            const existing = prev[key] || [];
            const filtered = existing.filter((item) => item.type !== currentType);
            return { ...prev, [key]: [...filtered, ...excelData], };
        });
    };

    const lessorAccess = JSON.parse(getGlobalCookie('lessorAccess') || 'null');
    const displayForJetstrem = lessorAccess?.id === 442;
    const roudingCondition =
        reserveRates?.reserve_rate_type?.value === 1 ||
        (reserveRates?.reserve_rate_type?.value === 2 &&
            reserveRates?.reserve_rate_based_on?.value &&
            !reserveRates?.table_based_esc &&
            (reserveRates?.reserve_rate_based_on?.value !== 4 || !reserveRates?.is_pbh_fixed_table)) ||
        (reserveRates?.reserve_rate_type?.value === 3 &&
            reserveRates?.reserve_rate_based_on?.value &&
            !(reserveRates?.reserve_rate_based_on?.value === 8 && reserveRates?.table_based_esc))
    return (
        <>
            <Dialog
                aria-labelledby="customized-dialog-title"
                className='add-lease-dialog'
                maxWidth='lg'
                fullWidth
                open={addEditReserveRate?.modal}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                    <Typography className="dialog-header-title">
                        {modeType === 'add' ? 'Add Reserve Rate' : modeType === 'edit' ? 'Edit Reserve Rate' : 'View Reserve Rate'}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                required
                                id="name"
                                value={reserveRates?.name}
                                onChange={(e, value) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("name", e.target.value.trimStart()) : e.preventDefault()}
                                label="Reserve Name"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                error={!!error.name}
                                helperText={error.name}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                                onFocus={() => onFocusChange("name")}
                                fullWidth
                                disabled={modeType === 'view'}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                options={pltConstants?.rate_account_types || []}
                                disabled={modeType === 'view'}
                                getOptionLabel={(option) => option?.name || option?.label || ""}
                                noOptionsText={modeType !== "view" && dropDownLoader?.rate_account_type ? "Loading..." : <Link onClick={() => navigate(`/settings/rate-account-type`)} sx={{ textDecoration: "none", cursor: "pointer" }} >+ Add New Account Type</Link>}
                                value={reserveRates?.account_type || null}
                                onChange={(e, value) => { onFieldChange("account_type", value); }}
                                onFocus={() => onFocusChange("account_type")}
                                isOptionEqualToValue={(option, value) => option?.id === value?.id || option?.name === value?.name}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                            <TextField
                                                {...params}
                                                label="Account Type"
                                                margin='normal'
                                                size='small'
                                                error={Boolean(error.account_type)}
                                                helperText={error.account_type}
                                                disabled={modeType === 'view'}
                                                slotProps={{
                                                    inputLabel: { shrink: true, },
                                                    input: {
                                                        ...params?.InputProps, endAdornment: (<>{modeType !== "view" && dropDownLoader?.rate_account_type && <CircularProgress color="inherit" size={20} />} {params?.InputProps?.endAdornment} </>)
                                                    }
                                                }}
                                            />
                                        </Tooltip>)
                                }}
                            />
                        </Grid>
                        {isQbEnabled && (
                            <Grid size={{ md: 4, xs: 12 }}>
                                <Autocomplete
                                    disablePortal
                                    options={productServices}
                                    getOptionLabel={(option) => option?.name || ""}
                                    noOptionsText={qbDropDownLoader.productService ? "Loading..." : "No Options Available"}
                                    value={reserveRates?.qb_product_and_service_id || null}
                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                    onChange={(e, value) => { onFieldChange("qb_product_and_service_id", value || null); setError(prev => ({ ...prev, qb_product_and_service_id: '' })) }}
                                    disabled={modeType === 'view'}
                                    slotProps={{ listbox: { sx: { maxHeight: 155 } } }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            required
                                            label="Product & Service"
                                            margin="normal"
                                            size="small"
                                            error={Boolean(error.qb_product_and_service_id)}
                                            helperText={error.qb_product_and_service_id || ''}
                                            slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{qbDropDownLoader.productService ? <CircularProgress color="inherit" size={20} /> : null}{params?.InputProps?.endAdornment}</>) } }}
                                            disabled={modeType === 'view'}
                                        />
                                    )}
                                />
                                {isQbEnabled && <Typography variant="h7" style={{ background: 'yellow', fontSize: '11px' }}> Last Synced by:{" "} <span style={{ fontSize: '10px', fontWeight: 'normal' }}> {productServices[0]?.qb_last_sync_by?.name ? `${productServices[0]?.qb_last_sync_by.name} (${productServices[0]?.last_synced_at ? moment(productServices[0]?.last_synced_at).format(displayDateFormatShort) : '--'})` : '--'} </span> </Typography>}
                            </Grid>
                        )}
                        {isQbEnabled && (
                            <Grid size={{ md: 4, xs: 12 }}>
                                <Autocomplete
                                    disablePortal
                                    options={chartOfAccounts}
                                    getOptionLabel={(option) => option?.name || ""}
                                    noOptionsText={qbDropDownLoader.chartOfAccount ? "Loading..." : "No Options Available"}
                                    value={reserveRates?.qb_chart_of_account_id || null}
                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                    onChange={(e, value) => { onFieldChange("qb_chart_of_account_id", value || null); setError(prev => ({ ...prev, qb_chart_of_account_id: '' })) }}
                                    disabled={modeType === 'view'}
                                    slotProps={{ listbox: { sx: { maxHeight: 155 } } }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            required
                                            label="Chart of Account"
                                            margin="normal"
                                            size="small"
                                            error={Boolean(error.qb_chart_of_account_id)}
                                            helperText={error.qb_chart_of_account_id || ''}
                                            slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{qbDropDownLoader.chartOfAccount ? <CircularProgress color="inherit" size={20} /> : null}{params?.InputProps?.endAdornment}</>) } }}
                                            disabled={modeType === 'view'}
                                        />
                                    )}
                                />
                                {isQbEnabled && <Typography variant="h7" style={{ background: 'yellow', fontSize: '11px' }}> Last Synced by:{" "} <span style={{ fontSize: '10px', fontWeight: 'normal' }}> {chartOfAccounts[0]?.qb_last_sync_by?.name ? `${chartOfAccounts[0]?.qb_last_sync_by.name} (${chartOfAccounts[0]?.last_synced_at ? moment(chartOfAccounts[0]?.last_synced_at).format(displayDateFormatShort) : '--'})` : '--'} </span> </Typography>}
                            </Grid>
                        )}
                        {isQbEnabled && hanwahaInstance && (
                            <Grid size={{ md: 4, xs: 12 }}>
                                <Autocomplete
                                    disablePortal
                                    options={classes}
                                    getOptionLabel={(option) => option?.name || ""}
                                    noOptionsText={qbDropDownLoader.class ? "Loading..." : "No Options Available"}
                                    value={reserveRates?.qb_class_id || null}
                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                    onChange={(e, value) => { onFieldChange("qb_class_id", value || null); setError(prev => ({ ...prev, qb_class_id: '' })) }}
                                    disabled={modeType === 'view'}
                                    slotProps={{ listbox: { sx: { maxHeight: 155 } } }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            required
                                            label="Class"
                                            margin="normal"
                                            size="small"
                                            error={Boolean(error.qb_class_id)}
                                            helperText={error.qb_class_id || ''}
                                            slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{qbDropDownLoader.class ? <CircularProgress color="inherit" size={20} /> : null}{params?.InputProps?.endAdornment}</>) } }}
                                            disabled={modeType === 'view'}
                                        />
                                    )}
                                />
                                {isQbEnabled && <Typography variant="h7" style={{ background:'yellow', fontSize:'11px' }}> Last Synced by:{" "} <span style={{ fontSize: '10px', fontWeight: 'normal' }}> {classes[0]?.qb_last_sync_by?.name ? `${classes[0]?.qb_last_sync_by.name} (${classes[0]?.last_synced_at ? moment(classes[0]?.last_synced_at).format(displayDateFormatShort) : '--'})` : '--'} </span> </Typography>}
                            </Grid>
                        )}
                        {isQbEnabled && hanwahaInstance && (
                            <Grid size={{ md: 4, xs: 12 }}>
                                <Autocomplete
                                    disablePortal
                                    options={subClasses}
                                    getOptionLabel={(option) => option?.name || ""}
                                    noOptionsText={qbDropDownLoader.subClass ? "Loading..." : "No Options Available"}
                                    value={reserveRates?.qb_sub_class_id || null}
                                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                    onChange={(e, value) => { onFieldChange("qb_sub_class_id", value || null); setError(prev => ({ ...prev, qb_sub_class_id: '' })) }}
                                    disabled={modeType === 'view' || !reserveRates?.qb_class_id}
                                    slotProps={{ listbox: { sx: { maxHeight: 155 } } }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            required
                                            label="Sub Class"
                                            margin="normal"
                                            size="small"
                                            error={Boolean(error.qb_sub_class_id)}
                                            helperText={error.qb_sub_class_id || ''}
                                            slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{qbDropDownLoader.subClass ? <CircularProgress color="inherit" size={20} /> : null}{params?.InputProps?.endAdornment}</>) } }}
                                            disabled={modeType === 'view' || !reserveRates?.qb_class_id}
                                        />
                                    )}
                                />
                            </Grid>
                        )}
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                options={pltConstants?.asset_types}
                                isOptionEqualToValue={(option, value) => option.asset_slug === value.asset_slug}
                                disabled={modeType === 'view' || dropDownLoader?.major_assembly}
                                getOptionLabel={(option) => {
                                    if (option?.is_grouped) {
                                        return option?.name || "";
                                    }

                                    return `${option?.asset_name || ""} ${option?.name || ""}`.trim();
                                }}
                                noOptionsText={modeType !== "view" && dropDownLoader?.major_assembly ? "Loading..." : "No Option Available"}
                                value={(leaseBasicDetails?.is_grouped || reserveRates?.is_grouped_lgs) && dropDownLoader?.major_assembly ? null : reserveRates?.major_assembly || null}
                                onChange={(e, value) => { onFieldChange("major_assembly", value); getAssetDropDown(value?.asset_slug) }}
                                onFocus={() => onFocusChange("major_assembly")}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow>
                                            <TextField
                                                required
                                                {...params}
                                                label="Major Assembly"
                                                margin='normal'
                                                size='small'
                                                error={Boolean(error.major_assembly)}
                                                helperText={error.major_assembly}
                                                disabled={modeType === 'view'}
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: true,
                                                    },
                                                    input: {
                                                        ...params?.InputProps, endAdornment: (<>{modeType !== "view" && dropDownLoader?.major_assembly && <CircularProgress color="inherit" size={20} />}
                                                            {params?.InputProps?.endAdornment}
                                                        </>
                                                        )
                                                    }
                                                }}
                                            />
                                        </Tooltip>)
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    required
                                    label="Start Date"
                                    value={reserveRates?.rate_start_date ? moment(reserveRates.rate_start_date) : null}
                                    // onChange={(data, value) => onFieldChange('rate_start_date', moment(data).format(backendDateFormat))}
                                    onChange={(data, value) => { onFieldChange('rate_start_date', data ? moment(data).format(backendDateFormat) : null); }}
                                    slotProps={{
                                        textField: {
                                            required: true,
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            helperText: error.rate_start_date,
                                            error: error.rate_start_date,
                                            onFocus: () => { onFocusChange("rate_start_date") }
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("rate_start_date", null);
                                            }
                                        },
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    required
                                    label="End Date"
                                    value={reserveRates?.rate_end_date ? moment(reserveRates.rate_end_date) : null}
                                    // onChange={(data, value) => onFieldChange('rate_end_date', moment(data).format(backendDateFormat))}
                                    onChange={(data, value) => { onFieldChange('rate_end_date', data ? moment(data).format(backendDateFormat) : null); }}
                                    minDate={reserveRates?.rate_start_date ? moment(reserveRates.rate_start_date) : null}
                                    slotProps={{
                                        textField: {
                                            required: ![5, 3].includes(leaseBasicDetails?.lease_duration_type?.value),
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            helperText: error.rate_end_date,
                                            error: error.rate_end_date,
                                            onFocus: () => { onFocusChange("rate_end_date") }
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("rate_end_date", null);
                                            }
                                        },
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />

                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                options={pltConstants?.constant_types?.filter(item => item.type === 'reserve_rate_type')}
                                disabled={modeType === 'view' || dropDownLoader?.account_type}
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                noOptionsText={modeType !== "view" && dropDownLoader?.account_type ? "Loading..." : "No Option Available"}
                                getOptionLabel={(option) => option.label || ""}
                                value={reserveRates?.reserve_rate_type || null}
                                onChange={(e, value) => onFieldChange("reserve_rate_type", value)}
                                onFocus={() => onFocusChange("reserve_rate_type")}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                            <TextField
                                                required
                                                {...params}
                                                label="Reserve Type"
                                                margin='normal'
                                                size='small'
                                                error={Boolean(error.reserve_rate_type)}
                                                helperText={error.reserve_rate_type}
                                                disabled={modeType === 'view'}
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: true,
                                                    },
                                                    input: {
                                                        ...params?.InputProps, endAdornment: <>{modeType !== "view" && dropDownLoader?.account_type && <CircularProgress color="inherit" size={20} />}
                                                            {params?.InputProps?.endAdornment}
                                                        </>
                                                    }
                                                }}
                                            />
                                        </Tooltip>)
                                }}
                            />
                        </Grid>
                        {reserveRates?.reserve_rate_type == null || reserveRates?.reserve_rate_type?.value === 1 ? <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                options={filteredIntervalData || []}
                                disabled={modeType === 'view'}
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                getOptionLabel={(option) => option.label || ""}
                                value={reserveRates?.interval || null}
                                onChange={(e, value) => onFieldChange("interval", value)}
                                onFocus={() => onFocusChange("interval")}
                                noOptionsText={modeType !== "view" && dropDownLoader?.interval ? "Loading..." : "No Option Available"}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow>
                                            <TextField
                                                required
                                                {...params}
                                                label="Interval"
                                                margin='normal'
                                                size='small'
                                                error={Boolean(error.interval)}
                                                helperText={error.interval}
                                                slotProps={{ inputLabel: { shrink: true, }, input: { ...params?.InputProps, endAdornment: <>{modeType !== "view" && dropDownLoader?.interval && <CircularProgress color="inherit" size={20} />} {params?.InputProps?.endAdornment} </> } }}
                                                disabled={modeType === 'view'}
                                            />
                                        </Tooltip>)
                                }}
                            />
                        </Grid> : ""}
                        {reserveRates?.reserve_rate_type == null || reserveRates?.reserve_rate_type?.value === 1 ?
                            <Grid size={{ md: 4, xs: 12 }}>
                                <TextField
                                    required
                                    id="reserve_rate_per_interval"
                                    value={modeType === 'view' && reserveRates?.reserve_rate_per_interval !== '' && reserveRates?.reserve_rate_per_interval !== null && reserveRates?.reserve_rate_per_interval !== undefined ? numberWithCommas(reserveRates?.reserve_rate_per_interval) : reserveRates?.reserve_rate_per_interval}
                                    onChange={(e, value) => { regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('reserve_rate_per_interval', e.target.value) : e.preventDefault() }}
                                    onFocus={() => onFocusChange("reserve_rate_per_interval")}
                                    label={
                                        <Box sx={{ display: 'inline-flex', alignItems: 'center', overflow: 'visible', whiteSpace: 'nowrap', cursor: "pointer" }}>
                                            Rate / Unit
                                            <Tooltip title="Note: Base reserve rate value should not include MUICP inflation rates and Adjustment factors"> <Box component="span" sx={{ display: 'inline-flex', ml: 0.5, }}> <InfoOutlineIcon fontSize="small" /> </Box> </Tooltip>
                                        </Box>
                                    }
                                    variant="outlined"
                                    size="small"
                                    margin="normal"
                                    error={!!error.reserve_rate_per_interval}
                                    helperText={error.reserve_rate_per_interval}
                                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 11 }, input: { startAdornment: (<InputAdornment position="start">{reserveRates?.currency?.symbol}</InputAdornment>) } }}
                                    fullWidth
                                    disabled={modeType === 'view'}
                                />
                            </Grid> : null}
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                options={pltConstants?.maintenance_events || []}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                noOptionsText={modeType !== "view" && dropDownLoader?.maintenance_events ? "Loading..." : "No Option Available"}
                                disabled={modeType === 'view'}
                                getOptionLabel={(option) => option.name || ""}
                                value={reserveRates?.maintenance_check_id || null}
                                onChange={(e, value) => onFieldChange("maintenance_check_id", value)}
                                onFocus={() => onFocusChange("maintenance_check_id")}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                            <TextField
                                                required
                                                {...params}
                                                label="Maintenance Event"
                                                margin='normal'
                                                size='small'
                                                error={Boolean(error.maintenance_check_id)}
                                                helperText={error.maintenance_check_id}
                                                disabled={modeType === 'view'}
                                                slotProps={{
                                                    inputLabel: {
                                                        shrink: true,
                                                    },
                                                    input: {
                                                        ...params?.InputProps, endAdornment: <>{modeType !== "view" && dropDownLoader?.maintenance_events && <CircularProgress color="inherit" size={20} />}
                                                            {params?.InputProps?.endAdornment}
                                                        </>
                                                    }
                                                }}
                                            />
                                        </Tooltip>)
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                options={pltConstants?.currencies || []}
                                disabled={modeType === 'view'}
                                getOptionLabel={(option) => option.name || ""}
                                value={reserveRates?.currency || null}
                                onChange={(e, value) => onFieldChange("currency", value)}
                                noOptionsText={modeType !== "view" && dropDownLoader?.currency ? "Loading..." : "No Option Available"}
                                onFocus={() => onFocusChange("currency")}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                renderInput={(params) => (
                                    <TextField
                                        required
                                        {...params}
                                        label="Currency"
                                        margin='normal'
                                        size='small'
                                        error={Boolean(error.currency)}
                                        helperText={error.currency}
                                        disabled={modeType === 'view'}
                                        slotProps={{
                                            inputLabel: {
                                                shrink: true,
                                            },
                                            input: {
                                                ...params?.InputProps, endAdornment: (<>{modeType !== "view" && dropDownLoader?.currency && <CircularProgress color="inherit" size={20} />}
                                                    {params?.InputProps?.endAdornment}
                                                </>
                                                )
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        {reserveRates?.major_assembly?.asset_type === 2 && !displayForJetstrem ? <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                options={pltConstants?.thrust?.engineTypes?.filter((item) => !(reserveRates?.engine_thrust_types || []).some((selected) => selected.id === item.id)) || []}
                                disabled={modeType === 'view' || dropDownLoader?.thrust}
                                getOptionLabel={(option) => option.name || ""}
                                value={reserveRates?.engine_thrust_types || []}
                                onChange={(e, value) => onFieldChange("engine_thrust_types", value)}
                                noOptionsText={modeType !== "view" && dropDownLoader?.thrust ? "Loading..." : "No Option Available"}
                                onFocus={() => onFocusChange("engine_thrust_types")}
                                multiple
                                size="small"
                                sx={{ '& .MuiAutocomplete-tag': { margin: '2px' } }}
                                slotProps={{ chip: { size: "small", sx: { height: 22, fontSize: "12px" } } }}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Engine Thrust Type"
                                        margin='normal'
                                        size='small'
                                        disabled={modeType === 'view'}
                                        slotProps={{
                                            inputLabel: {
                                                shrink: true,
                                            },
                                            input: {
                                                ...params?.InputProps, endAdornment: (<>{modeType !== "view" && dropDownLoader?.thrust && <CircularProgress color="inherit" size={20} />}
                                                    {params?.InputProps?.endAdornment}
                                                </>
                                                )
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Grid> : null}
                        {/* Grid For Interval Table */}
                        {reserveRates?.reserve_rate_type !== null && reserveRates?.reserve_rate_type?.value !== 1 ? <Grid size={{ md: 12, xs: 12 }}>
                            <Box className="escalation-container">
                                <Box className="range-box-reserve" >
                                    <Grid container spacing={1} rowSpacing={1} style={{ margin: "10px 10px 0px 0px" }} >
                                        <Grid size={{ md: 3, xs: 12 }}>
                                            <Autocomplete
                                                disablePortal
                                                disableClearable
                                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                                options={filteredIntervalData || []}
                                                disabled={modeType === 'view'}
                                                getOptionLabel={(option) => option.label || ""}
                                                value={reserveRates?.reserve_rate_based_on}
                                                onChange={(e, value) => onFieldChange("reserve_rate_based_on", value)}
                                                onFocus={() => onFocusChange("reserve_rate_based_on")}
                                                noOptionsText={modeType !== "view" && dropDownLoader?.account_type ? "Loading..." : "No Option Available"}
                                                renderInput={(params) => {
                                                    const selectedLabel = params?.inputProps?.value || "";
                                                    return (
                                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="right" arrow >
                                                            <TextField
                                                                {...params}
                                                                required
                                                                label="Reserve Rate Based On"
                                                                margin='normal'
                                                                size='small'
                                                                slotProps={{ inputLabel: { shrink: true, }, input: { ...params?.InputProps, endAdornment: (<>{modeType !== "view" && dropDownLoader?.account_type && <CircularProgress color="inherit" size={20} />} {params?.InputProps?.endAdornment} </>) } }}
                                                                error={error.reserve_rate_based_on}
                                                                helperText={error.reserve_rate_based_on}
                                                                disabled={modeType === 'view'}
                                                            />
                                                        </Tooltip>)
                                                }}
                                            />
                                        </Grid>
                                        {[2, 3, 4, 6].includes(reserveRates?.reserve_rate_based_on?.value) ? <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 1 }}>
                                            <FormControl component="fieldset">
                                                <FormLabel component="legend" sx={{ color: '#1F1F1F', '&.Mui-focused': { color: '#1F1F1F' }, fontSize: '14px' }}>Range Condition To Be Considered</FormLabel>
                                                <RadioGroup
                                                    row
                                                    value={
                                                        reserveRates?.is_pbh_fixed_table
                                                            ? "fixed"
                                                            : reserveRates?.fixed_rate
                                                                ? "fixed_rate"
                                                                : reserveRates?.pbh_range_type?.toString()
                                                    }
                                                    onChange={(e) => {
                                                        handlePbhRangeTypeChange(e.target.value);
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        value={false}
                                                        control={<Radio disableRipple />}
                                                        label="Either Off"
                                                        disabled={modeType === 'view'}
                                                    />
                                                    <FormControlLabel
                                                        value={true}
                                                        control={<Radio disableRipple />}
                                                        label="ALL"
                                                        disabled={modeType === 'view'}
                                                    />
                                                    {reserveRates?.reserve_rate_based_on?.value === 4 ? <>
                                                        <FormControlLabel
                                                            value="fixed"
                                                            control={<Radio disableRipple />}
                                                            label="Fixed Table"
                                                            disabled={modeType === 'view'}
                                                        />
                                                        <FormControlLabel
                                                            value="fixed_rate"
                                                            control={<Radio disableRipple />}
                                                            label="Fixed Rate"
                                                            disabled={modeType === 'view'}
                                                        />

                                                    </> : null}
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid> : null}
                                        {reserveRates?.is_pbh_fixed_table && <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 1 }}>
                                            <Box sx={{ width: "100%" }} >
                                                <Typography sx={{ fontSize: "14px", fontWeight: 600, mb: 1, display: "inline-flex", alignItems: "center", gap: 0.5 }}>
                                                    Fixed Table Conditions
                                                    <Tooltip title="Enter a Fixed Rate and at least one of Flight Cycles or Flight Hours."  >
                                                        <Box component="span" sx={{ display: "inline-flex", cursor: "pointer" }}>
                                                            <InfoIcon fontSize="8px" color="primary" />
                                                        </Box>
                                                    </Tooltip>
                                                </Typography>
                                                <TableContainer className='scrollable-table-container'>
                                                    <Table size="small" className="mui-table-format">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell sx={{ fontWeight: 600, minWidth: '100px !important' }}> Type</TableCell>
                                                                {fixedTableRows.map((row) => (
                                                                    <TableCell key={row.key}>
                                                                        {row.label}{row?.key === 'fixed' ? '*' : ""}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell> Rate</TableCell>
                                                                {fixedTableRows.map((row) => (
                                                                    <TableCell key={row.key}>
                                                                        <TextField
                                                                            fullWidth
                                                                            required
                                                                            size="small"
                                                                            variant="outlined"
                                                                            sx={{ maxWidth: 200, mx: "auto" }}
                                                                            value={modeType === 'view' && reserveRates?.fixed_table_condition?.[row.key] !== '' && reserveRates?.fixed_table_condition?.[row.key] !== null && reserveRates?.fixed_table_condition?.[row.key] !== undefined ? numberWithCommas(reserveRates?.fixed_table_condition?.[row.key]) : (reserveRates?.fixed_table_condition?.[row.key] ?? "")}
                                                                            onChange={(e) => { regexConstants.decimalnodotstart.test(e.target.value) || e.target.value === "" ? onFieldChange("fixed_table_condition", { [row.key]: e.target.value }) : e.preventDefault(); }}
                                                                            onFocus={() => setError(prev => ({ ...prev, fixed_table_condition: { ...prev?.fixed_table_condition, [row.key]: "" } }))}
                                                                            error={Boolean(error?.fixed_table_condition?.[row.key])}
                                                                            helperText={error?.fixed_table_condition?.[row.key]}
                                                                            disabled={modeType === 'view'}
                                                                            slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 11 }, input: { startAdornment: (<InputAdornment position="start">{reserveRates?.currency?.symbol}</InputAdornment>) } }}
                                                                        />
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Box>
                                        </Grid>}
                                        {reserveRates?.reserve_rate_type?.value === 2 && reserveRates?.reserve_rate_based_on?.value === 4 && reserveRates?.fixed_rate ?
                                            <Grid size={{ md: 3, xs: 12 }}>
                                                <TextField
                                                    required
                                                    id="reserve_rate_per_interval"
                                                    value={modeType === 'view' && reserveRates?.reserve_rate_per_interval !== '' && reserveRates?.reserve_rate_per_interval !== null && reserveRates?.reserve_rate_per_interval !== undefined ? numberWithCommas(reserveRates?.reserve_rate_per_interval) : reserveRates?.reserve_rate_per_interval}
                                                    onChange={(e, value) => { regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('reserve_rate_per_interval', e.target.value) : e.preventDefault() }}
                                                    onFocus={() => onFocusChange("reserve_rate_per_interval")}
                                                    label={
                                                        <Box sx={{ display: 'inline-flex', alignItems: 'center', overflow: 'visible', whiteSpace: 'nowrap', cursor: "pointer" }}>
                                                            Rate / Unit
                                                            <Tooltip title="Note: Base reserve rate value should not include MUICP inflation rates and Adjustment factors"> <Box component="span" sx={{ display: 'inline-flex', ml: 0.5, }}> <InfoOutlineIcon fontSize="small" /> </Box> </Tooltip>
                                                        </Box>
                                                    }
                                                    variant="outlined"
                                                    size="small"
                                                    margin="normal"
                                                    error={!!error.reserve_rate_per_interval}
                                                    helperText={error.reserve_rate_per_interval}
                                                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 11 }, input: { startAdornment: (<InputAdornment position="start">{reserveRates?.currency?.symbol}</InputAdornment>) } }}
                                                    fullWidth
                                                    disabled={modeType === 'view'}
                                                />
                                            </Grid>
                                            : null}
                                        {[8, 9, 10, 11].includes(reserveRates?.reserve_rate_based_on?.value) ? <Grid size={{ md: 3, xs: 12 }}>
                                            <Autocomplete
                                                disablePortal
                                                disableClearable
                                                options={filteredIntervalList || []}
                                                disabled={modeType === 'view'}
                                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                                getOptionLabel={(option) => option.label || ""}
                                                value={reserveRates?.interval || null}
                                                onChange={(e, value) => onFieldChange("interval", value)}
                                                onFocus={() => onFocusChange("interval")}
                                                noOptionsText={modeType !== "view" && dropDownLoader?.account_type ? "Loading..." : "No Option Available"}
                                                renderInput={(params) => {
                                                    const selectedLabel = params?.inputProps?.value || "";
                                                    return (
                                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow>
                                                            <TextField
                                                                required
                                                                {...params}
                                                                label="Reserve Rate Interval"
                                                                margin='normal'
                                                                size='small'
                                                                error={Boolean(error.interval)}
                                                                helperText={error.interval}
                                                                slotProps={{ inputLabel: { shrink: true }, input: { ...params?.InputProps, endAdornment: (<>{modeType !== "view" && dropDownLoader?.account_type && <CircularProgress color="inherit" size={20} />} {params?.InputProps?.endAdornment} </>) } }}
                                                                disabled={modeType === 'view'}
                                                            />
                                                        </Tooltip>)
                                                }}
                                            />
                                        </Grid> : null}
                                        {[8, 9, 10, 11].includes(reserveRates?.reserve_rate_based_on?.value) ? <Grid size={{ md: 3, xs: 12 }}>
                                            {(() => {
                                                let options = [{ label: '1', value: 1 }, { label: '2', value: 2 }, { label: '3', value: 3 }, { label: '4', value: 4 }, { label: '5', value: 5 }, { label: '6', value: 6 },];
                                                return (
                                                    <Autocomplete
                                                        disablePortal
                                                        disableClearable
                                                        options={options}
                                                        disabled={modeType === 'view'}
                                                        isOptionEqualToValue={(option, value) => option.value === value.value}
                                                        getOptionLabel={(option) => option.label || ""}
                                                        value={options.find(opt => opt.value === reserveRates?.allow_decimal?.value) || null}
                                                        onChange={(e, value) => onFieldChange("allow_decimal", value)}
                                                        onFocus={() => onFocusChange("allow_decimal")}
                                                        noOptionsText="No Option Available"
                                                        renderInput={(params) => (
                                                            <TextField
                                                                required
                                                                {...params}
                                                                label={
                                                                    <span style={{ verticalAlign: 'super' }}>
                                                                        Allow Decimal
                                                                        <Tooltip placement='right' title={<span>Specifies the decimal precision to which the FH/FC ratio from utilisation is rounded before matching against the Ratio Table.</span>} arrow>
                                                                            <InfoIcon fontSize='18px' color='primary' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: '18px', cursor: "pointer" }} />
                                                                        </Tooltip>
                                                                    </span>
                                                                } margin='normal'
                                                                size='small'
                                                                error={Boolean(error.allow_decimal)}
                                                                helperText={error.allow_decimal}
                                                                slotProps={{ inputLabel: { shrink: true } }}
                                                                disabled={modeType === 'view'}
                                                            />
                                                        )}
                                                    />
                                                )
                                            })()}
                                        </Grid> : null}
                                        {[8, 9, 11].includes(reserveRates?.reserve_rate_based_on?.value) ? <Grid size={{ md: 3, xs: 12 }}>
                                            {(() => {
                                                let options = [{ label: 'Rounding Up', value: 1 }, { label: 'Rounding Down', value: 2 }, { label: 'Rounding Off', value: 3 }, { label: 'No Rounding', value: 4 }
                                                ];
                                                return (
                                                    <Autocomplete
                                                        disablePortal
                                                        disableClearable
                                                        options={options}
                                                        disabled={modeType === 'view'}
                                                        isOptionEqualToValue={(option, value) => option.value === value.value}
                                                        getOptionLabel={(option) => option.label || ""}
                                                        value={reserveRates?.rounding || null}
                                                        onChange={(e, value) => onFieldChange("rounding", value)}
                                                        onFocus={() => onFocusChange("rounding")}
                                                        noOptionsText="No Option Available"
                                                        renderInput={(params) => {
                                                            const selectedLabel = params?.inputProps?.value || "";
                                                            return (
                                                                <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                                                    <TextField
                                                                        required
                                                                        {...params}
                                                                        label={
                                                                            <span style={{ verticalAlign: 'super' }}>
                                                                                Rounding
                                                                                <Tooltip placement='right' title={<span>Determines how the FH/FC ratio is rounded to the selected decimal places — Round Up (ceiling), Round Down (floor/truncate), Round Off (standard), or No Rounding (use raw ratio value).</span>} arrow>
                                                                                    <InfoIcon fontSize='18px' color='primary' style={{ verticalAlign: 'middle', marginLeft: '2px', fontSize: '18px', cursor: "pointer" }} />
                                                                                </Tooltip>
                                                                            </span>
                                                                        }
                                                                        margin='normal'
                                                                        size='small'
                                                                        error={Boolean(error.rounding)}
                                                                        helperText={error.rounding}
                                                                        slotProps={{ inputLabel: { shrink: true } }}
                                                                        disabled={modeType === 'view'}
                                                                    />
                                                                </Tooltip>)
                                                        }}
                                                    />
                                                )
                                            })()}
                                        </Grid> : <Grid size={{ md: 3, xs: 12 }}></Grid>}
                                        {!reserveRates?.is_pbh_fixed_table && !reserveRates?.fixed_rate && [2, 3, 4, 6, 8].includes(reserveRates?.reserve_rate_based_on?.value) ? <Grid size={{ md: 12, xs: 12 }}>
                                            <FormGroup className='disabled-checkbox-wrapper'>
                                                <Box style={{ display: 'flex', alignItems: 'center', marginLeft: "-12px" }}>
                                                    <Checkbox checked={reserveRates?.table_based_esc}
                                                        onChange={(e) => onFieldChange('table_based_esc', e.target.checked)}
                                                        disabled={modeType === 'view'} disableRipple />
                                                    <span className="check-item-span">Enable Escalation From Table</span>
                                                </Box>
                                            </FormGroup>
                                        </Grid> : null}
                                        {[9, 10, 11].includes((reserveRates?.reserve_rate_based_on?.value)) ? <Grid item xs={12} md={12}> <InterpolationExtrapolation projectionData={reserveRates} modeType={modeType} onFieldChange={onFieldChange} /></Grid> : null}

                                    </Grid>
                                </Box>
                                <Box className="rate-table-wrapper">
                                    {!reserveRates?.is_pbh_fixed_table && !reserveRates?.fixed_rate && [2, 3, 4, 6, 8].includes(reserveRates?.reserve_rate_based_on?.value) ?
                                        <RangeConditionTable
                                            reserveBasedOn={reserveRates?.reserve_rate_based_on?.value === 4 ? 2 : reserveRates?.reserve_rate_based_on?.value}
                                            tableData={reserveRates?.reserve_rate_based_on?.value === 4 ? reserveRates?.pbh_condition?.filter(item => item.type === 2) : sortingArray(reserveRates?.pbh_condition, "range")}
                                            pltConstants={pltConstants}
                                            onFieldChange={onFieldChange}
                                            onMultiFieldChange={onMultiFieldChange}
                                            onMultiDelete={onMultiDelete}
                                            onAddMultiRow={() => onAddMultiRow(reserveRates?.reserve_rate_based_on?.value === 4 ? 2 : reserveRates?.reserve_rate_based_on?.value)}
                                            modeType={modeType}
                                            reserveRates={reserveRates}
                                            error={error}
                                            setError={setError}
                                            excelData={excelData}
                                            onImportExcel={onImportExcel}
                                            setExcelData={setExcelData}
                                        /> : null}
                                    {[9, 10].includes(reserveRates?.reserve_rate_based_on?.value) ?
                                        <CustomRatioDerateTable
                                            ratioDerateData={reserveRates}
                                            onMultiFieldChange={onMultiFieldChange}
                                            onMultiDelete={onMultiDelete}
                                            onAddMultiRow={onAddMultiRow}
                                            modeType={modeType}
                                            rateBasedOn={reserveRates?.reserve_rate_based_on?.value}
                                            error={error}
                                            onFocusChange={onFocusChange}
                                            excelData={excelData}
                                            onImportExcel={onImportExcel}
                                            setExcelData={setExcelData}
                                            handleItemClicked={handleItemClicked}
                                        />
                                        : null}
                                    {reserveRates?.reserve_rate_based_on?.value === 11 ?
                                        <DerateBasedRatioTable
                                            ratioDerateData={reserveRates}
                                            setRatioDerateData={setReserveRates}
                                            modeType={modeType}
                                            page="Reserve"
                                            setError={setError}
                                            error={error}
                                            onFocusChange={onFocusChange}
                                            handleItemClicked={handleItemClicked}
                                        />
                                        : null}
                                </Box>
                                {!reserveRates?.is_pbh_fixed_table && !reserveRates?.fixed_rate && reserveRates?.reserve_rate_based_on?.value === 4 && (
                                    <Box className="rate-table-wrapper">
                                        <RangeConditionTable
                                            tableData={sortingArray(reserveRates?.pbh_condition?.filter(item => item.type === 3), "range")}
                                            reserveBasedOn={3}
                                            pltConstants={pltConstants}
                                            onMultiFieldChange={onMultiFieldChange}
                                            onMultiDelete={onMultiDelete}
                                            onAddMultiRow={() => onAddMultiRow(3)}
                                            modeType={modeType}
                                            reserveRates={reserveRates}
                                            error={error}
                                            setError={setError}
                                            onImportExcel={onImportExcel}
                                            excelData={excelData}
                                            setExcelData={setExcelData}
                                        /></Box>
                                )}
                                {[9, 10, 11].includes(reserveRates?.reserve_rate_based_on?.value) ? <Box className="rate-table-wrapper" sx={{ paddingTop: "0px" }}>
                                    <Box marginLeft={-1} sx={{ cursor: modeType === "view" ? "not-allowed" : "pointer" }}>
                                        <Checkbox
                                            checked={reserveRates?.is_base_reading || false}
                                            onChange={(e) => onFieldChange('is_base_reading', e.target.checked)}
                                            disabled={modeType === 'view'} disableRipple />
                                        <span className="check-item-span" style={{ fontSize: "14px" }}>Enable Base Reading</span>
                                    </Box>
                                    {reserveRates?.is_base_reading ? <Grid container spacing={2} style={{ marginTop: "10px" }} >
                                        {[9, 11].includes(reserveRates?.reserve_rate_based_on?.value) ? <Grid size={{ md: 3, xs: 12 }}>
                                            <TextField
                                                required
                                                id="base_ratio}"
                                                value={reserveRates?.base_ratio || ''}
                                                onChange={(e) => { regexConstants.decimalNoDotStartWithVariables(reserveRates?.allow_decimal?.value).test(e.target.value) ? onFieldChange("base_ratio", e.target.value) : e.preventDefault() }}
                                                label="Base Ratio"
                                                variant="outlined"
                                                size="small"
                                                margin="normal"
                                                error={!!error.base_ratio}
                                                helperText={error.base_ratio}
                                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 11 } }}
                                                onFocus={() => onFocusChange("base_ratio")}
                                                fullWidth
                                                disabled={modeType === 'view'}
                                            />
                                        </Grid> : null}
                                        {[10, 11].includes(reserveRates?.reserve_rate_based_on?.value) ? <Grid size={{ md: 3, xs: 12 }}>
                                            <TextField
                                                required
                                                id="base_derate"
                                                value={reserveRates?.base_derate || ''}
                                                onChange={(e) => { regexConstants.decimalNoDotStartWithVariables(reserveRates?.allow_decimal?.value).test(e.target.value) ? onFieldChange("base_derate", e.target.value) : e.preventDefault() }}
                                                label={`Base Derate${reserveRates?.interval?.label ? `/${reserveRates?.interval?.label}` : ""}`}
                                                variant="outlined"
                                                size="small"
                                                margin="normal"
                                                error={!!error.base_derate}
                                                helperText={error.base_derate}
                                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 11 } }}
                                                onFocus={() => onFocusChange("base_derate")}
                                                fullWidth
                                                disabled={modeType === 'view'}
                                            />
                                        </Grid> : null}
                                        <Grid size={{ md: 3, xs: 12 }}>
                                            <TextField
                                                required
                                                id="name"
                                                value={modeType === 'view' && reserveRates?.base_rate !== '' && reserveRates?.base_rate !== null && reserveRates?.base_rate !== undefined ? numberWithCommas(reserveRates?.base_rate) : (reserveRates?.base_rate ? reserveRates?.base_rate : '')}
                                                onChange={(e) => { regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange("base_rate", e.target.value,) : e.preventDefault() }}
                                                label={`Base Rate${reserveRates?.interval?.label ? `/${reserveRates?.interval?.label}` : ""}`}
                                                variant="outlined"
                                                size="small"
                                                margin="normal"
                                                error={!!error.base_rate}
                                                helperText={error.base_rate}
                                                slotProps={{
                                                    inputLabel: { shrink: true },
                                                    htmlInput: {
                                                        maxLength: 11,
                                                    },
                                                    input: { startAdornment: (<InputAdornment position="start">{reserveRates?.currency?.symbol}</InputAdornment>) }
                                                }}
                                                onFocus={() => onFocusChange("base_rate")}
                                                fullWidth
                                                disabled={modeType === 'view'}
                                            />
                                        </Grid>
                                        <Grid size={{ md: 3, xs: 12 }}>
                                            <FormGroup className='disabled-checkbox-wrapper'>
                                                <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: "-12px", cursor: modeType === 'view' ? "not-allowed" : "pointer" }}>
                                                    <Checkbox
                                                        checked={reserveRates?.base_reading_escaltaion || false}
                                                        onChange={(e) => onFieldChange('base_reading_escaltaion', e.target.checked)}
                                                        disabled={modeType === 'view'}
                                                        disableRipple
                                                    />
                                                    <span className="check-item-span">Base Reading Escalation</span>
                                                </Box>
                                            </FormGroup>
                                        </Grid>
                                    </Grid> : null}
                                </Box> : null}
                            </Box>
                        </Grid> : null}
                        {reserveRates?.interval?.value === 1 ?
                            <Box sx={{ width: '100%', }} className="escalation-container" >
                                <Typography className='section-header-text'><u>Pro-rated Rate Details:</u></Typography>
                                <ProRateDetails reserveRates={reserveRates} onFieldChange={onFieldChange} modeType={modeType} error={error} onFocusChange={onFocusChange} />
                            </Box>
                            : null}
                        <Grid size={{ md: 12, xs: 12 }}>
                            <Typography className='section-header-text'><u>Escalation Details:</u></Typography>
                            <EscalationDetails dropDownLoader={dropDownLoader} reserveRates={reserveRates} leaseBasicDetails={leaseBasicDetails} onFieldChange={onFieldChange} onFocusChange={onFocusChange} error={error} modeType={modeType} pltConstants={pltConstants} requireBaseReadingEscalation={reserveRates?.is_base_reading && reserveRates?.base_reading_escaltaion === true} />
                        </Grid>
                        {(leshaBankInstance || MTAviationInstance || avationPlcInstance) ?
                            <Grid size={{ md: 12, xs: 12 }}>
                                <Paper>
                                    <Table className="mui-table-format">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell></TableCell>
                                                <TableCell sx={{ padding: '5px 10px 5px 15px  !important' }} >Yes</TableCell>
                                                <TableCell sx={{ padding: '5px 10px 5px 20px  !important' }}>No</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {eolAdjFields?.map((item, index) => {
                                                return (
                                                    <TableRow>
                                                        <TableCell>{item?.label}</TableCell>
                                                        <TableCell> <Checkbox
                                                            checked={item?.value === 1}
                                                            onChange={(e) => {
                                                                handleEolAdjFields(index, 1)
                                                            }}
                                                            disabled={modeType === 'view'}
                                                            size='small' /></TableCell>
                                                        <TableCell><Checkbox
                                                            checked={item?.value === 0}
                                                            onChange={(e) => {
                                                                handleEolAdjFields(index, 0)
                                                            }}
                                                            disabled={modeType === 'view'}
                                                            size='small' /></TableCell>
                                                    </TableRow>
                                                )
                                            })}
                                        </TableBody>
                                    </Table>
                                </Paper>
                            </Grid> : null}
                        <Grid size={{ md: 4, xs: 12 }}>
                            <FormGroup className='disabled-checkbox-wrapper'>
                                <Box className="check-item-div" sx={{ cursor: modeType === "view" ? 'not-allowed' : "pointer" }}>
                                    <Checkbox
                                        checked={reserveRates?.is_notional_mr}
                                        onChange={(e) => onFieldChange('is_notional_mr', e.target.checked)}
                                        disabled={modeType === 'view'}
                                        disableRipple
                                        sx={{ paddingLeft: 0, }}
                                    />
                                    <span className="check-item-span">Is Notional Reserve</span>
                                </Box>
                            </FormGroup>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <FormGroup className='disabled-checkbox-wrapper'>
                                <Box style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: modeType === "view" ? 'not-allowed' : "pointer" }}>
                                    <Checkbox checked={reserveRates?.status} onChange={(e) => onFieldChange('status', e.target.checked)} disabled={modeType === 'view'} disableRipple sx={{ paddingLeft: 0, }} />
                                    <span className="check-item-span">Activate Reserve Account</span>
                                </Box>
                            </FormGroup>
                        </Grid>
                        {reserveRates?.major_assembly?.asset_type === 2 ? <Grid size={{ md: 4, xs: 12 }}>
                            <FormGroup className='disabled-checkbox-wrapper'>
                                <Box style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: modeType === "view" ? 'not-allowed' : "pointer" }}>
                                    <Checkbox checked={reserveRates?.region_based_esc} onChange={(e) => onFieldChange('region_based_esc', e.target.checked)} disabled={modeType === 'view'} disableRipple sx={{ paddingLeft: 0, }} />
                                    <span className="check-item-span">Enable Region based Escalation</span>
                                </Box>
                            </FormGroup>
                        </Grid> : null}
                        {reserveRates?.major_assembly?.asset_type !== 2 && <Grid size={{ md: 4, xs: 12 }}></Grid>}
                        {reserveRates?.interval?.value !== 1 ?
                            <Grid size={{ md: 4, xs: 12 }}>
                                <FormGroup className='disabled-checkbox-wrapper'>
                                    <Box className="check-item-div" sx={{ cursor: modeType === "view" ? 'not-allowed' : "pointer" }}>
                                        <Checkbox checked={reserveRates?.max_cap_applicable} onChange={(e) => { onFieldChange('max_cap_applicable', e.target.checked) }} disabled={modeType === 'view'} disableRipple sx={{ paddingLeft: 0, }} />
                                        <Box
                                            sx={{ display: 'inline-flex', alignItems: 'center', overflow: 'visible', whiteSpace: 'nowrap', cursor: "pointer", fontSize: "14px" }}
                                        >
                                            Enable Max Cap Amount
                                            <Tooltip title="Click here to enable max cap amount.Even Escalated Amount will be Restricted to this amount">
                                                <Box
                                                    component="span"
                                                    sx={{ display: 'inline-flex', ml: 0.5, }}
                                                >
                                                    <InfoOutlineIcon fontSize="small" sx={{ fontSize: 16 }} />
                                                </Box>
                                            </Tooltip>
                                        </Box>
                                    </Box>
                                </FormGroup>
                            </Grid> : null}
                        {/* {reserveRates?.major_assembly?.asset_type !==2 && reserveRates?.interval?.value !== 1 &&   <Grid size={{ md: 4, xs: 12 }}></Grid>} */}
                        {reserveRates?.reserve_rate_type?.value === 1 ? <Grid size={{ md: 4, xs: 12 }}>
                            <Grid size={{ md: 12, xs: 12 }}>
                                <FormGroup className='disabled-checkbox-wrapper'>
                                    <Box style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: modeType === "view" ? 'not-allowed' : "pointer" }}>
                                        <Checkbox checked={reserveRates?.is_additional_amount} onChange={(e) => { onFieldChange('is_additional_amount', e.target.checked) }} disabled={modeType === 'view'} disableRipple sx={{ paddingLeft: 0, }} />
                                        <span className="check-item-span">Additional Cost Applicable</span>
                                    </Box>
                                </FormGroup>
                            </Grid>
                        </Grid> : null}

                        <Grid size={{ md: 4, xs: 12 }}></Grid>
                        {reserveRates?.reserve_rate_type?.value !== 1 ? <Grid size={{ md: 4, xs: 12 }}></Grid> : null}
                        {reserveRates?.interval?.value !== 1 ?
                            <Grid size={{ md: 4, xs: 12 }}>
                                <div style={{ marginTop: "-10px" }}>  <TextField
                                    required={reserveRates?.max_cap_applicable}
                                    id="max_cap_amount"
                                    value={modeType === 'view' && reserveRates?.max_cap_amount !== '' && reserveRates?.max_cap_amount !== null && reserveRates?.max_cap_amount !== undefined ? numberWithCommas(reserveRates?.max_cap_amount) : reserveRates?.max_cap_amount}
                                    onChange={(e, value) => { regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('max_cap_amount', e.target.value) : e.preventDefault() }}
                                    onFocus={() => onFocusChange("max_cap_amount")}
                                    label="Enter Max Cap Amount"
                                    variant="outlined"
                                    size="small"
                                    margin="normal"
                                    error={error.max_cap_amount}
                                    helperText={error.max_cap_amount}
                                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 11 }, input: { startAdornment: (<InputAdornment position="start">{reserveRates?.currency?.symbol}</InputAdornment>) } }}
                                    fullWidth
                                    disabled={modeType === 'view' || !reserveRates?.max_cap_applicable}
                                /></div>

                            </Grid> : <Grid size={{ md: 4, xs: 12 }}></Grid>}
                        {reserveRates?.reserve_rate_type?.value === 1 ? <Grid size={{ md: 4, xs: 12 }}>
                            <div style={{ marginTop: "-10px" }}>
                                <TextField
                                    required={reserveRates?.is_additional_amount}
                                    id="additional_amount"
                                    value={modeType === 'view' && reserveRates?.additional_amount !== '' && reserveRates?.additional_amount !== null && reserveRates?.additional_amount !== undefined ? numberWithCommas(reserveRates?.additional_amount) : reserveRates?.additional_amount}
                                    onChange={(e, value) => { regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('additional_amount', e.target.value) : e.preventDefault() }}
                                    onFocus={() => onFocusChange("additional_amount")}
                                    label="Enter Additional Cost"
                                    variant="outlined"
                                    size="small"
                                    margin="normal"
                                    error={!!error.additional_amount}
                                    helperText={error.additional_amount}
                                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 11 }, input: { startAdornment: (<InputAdornment position="start">{reserveRates?.currency?.symbol}</InputAdornment>) } }}
                                    fullWidth
                                    disabled={modeType === 'view' || !reserveRates?.is_additional_amount}
                                />
                            </div>
                        </Grid> : null}
                        {roudingCondition ? <Grid size={{ md: 4, xs: 12 }}>
                            <div style={{ marginTop: "-10px" }}> <Autocomplete
                                disablePortal
                                options={pltConstants?.constant_types?.filter(item => item.type === 'round_off_escalation')}
                                disabled={modeType === 'view'}
                                getOptionLabel={(option) => option.label || ""}
                                value={reserveRates?.round_off_escalation || null}
                                onChange={(e, value) => onFieldChange("round_off_escalation", value)}
                                onFocus={() => onFocusChange("round_off_escalation")}
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Esc. Rate Rounding"
                                        margin='normal'
                                        size='small'
                                        slotProps={{ inputLabel: { shrink: true } }}
                                        disabled={modeType === 'view'}
                                    />
                                )}
                            /></div>
                        </Grid> : null}


                        {/* <Grid container spacing={2} > */}
                        <Grid size={{ md: 12, xs: 12 }} >
                            <TextField
                                id="remarks"
                                value={reserveRates?.remarks_reserve}
                                onChange={(e, value) => onFieldChange('remarks_reserve', e.target.value)}
                                label="Remarks"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                slotProps={{ inputLabel: { shrink: true } }}
                                sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                fullWidth
                                rows={3}
                                multiline
                                disabled={modeType === 'view'}
                            />
                        </Grid>

                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    required
                                    label="Remarks Date"
                                    value={reserveRates?.remark_date ? moment(reserveRates.remark_date) : null}
                                    onChange={(data, value) => { onFieldChange('remark_date', data ? moment(data).format(backendDateFormat) : null); }}
                                    slotProps={{
                                        textField: {
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("remark_date", null);
                                            }
                                        },
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />

                            </LocalizationProvider>
                        </Grid>
                        {isLGGrouping && <Grid size={{ md: 12, xs: 12 }}>
                            <Typography className='section-header-text'><u>Invoice Amount Allocation:</u></Typography>
                            <LGGroupingAllocation modeType={modeType} reserveRates={reserveRates} onMultiFieldChange={onMultiFieldChange} />
                        </Grid>}
                        {reserveRates?.major_assembly?.asset_type === 2 && <Grid size={{ md: 12, xs: 12 }}>
                            <Typography className='section-header-text'><u>SV Claim Details:</u></Typography>
                            <SvClaimDetails claimData={reserveRates} isLoading={isLoading} onFieldChange={onFieldChange} modeType={modeType} pltConstants={pltConstants} onMultiFieldChange={onMultiFieldChange} isReserveRate={true} error={error} onFocusChange={onFocusChange} />
                        </Grid>}

                        <Grid size={{ md: 12, xs: 12 }}>
                            <Box className="responsive-buttons">
                                {reserveRates?.id && updatedReserveData?.data?.attachments?.length ?
                                    <Button onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({updatedReserveData?.data?.attachments?.length})Attachment(s)</Button> :
                                    <Button color='primary' variant='outlined' size='small' sx={{ marginBottom: '10px' }}>Attachments</Button>
                                }
                                <Button className='available-space-btn' size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                            </Box>
                            {modeType === 'view' ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={updatedReserveData?.data?.attachments} remainingStorage={storageDetails?.remaining_storage} isNote={`'PRSV severity', 'PRSV severity table', 'de-rate', 'de-rate table', 'Lessor contribution language', 'Lease agreement', 'lessor contribution language', 'lease agreement'`} />}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className='cancel-btn' variant='outlined' size='small' disabled={isLoading?.pageLoader} onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null : <Button variant='contained' className='btn-primary' size='small' onClick={() => { handleItemClicked('Save Button'); onAddEditReserveRate(); }}> Save </Button>}
                </DialogActions>
            </Dialog>
            {(isLoading?.pageLoader || qbStatusLoading || qbDropDownLoader.productService || qbDropDownLoader.chartOfAccount || qbDropDownLoader.class) ? <PageLoader /> : null}
        </>
    )
}
export default ReserveRateCRU
